const messages = {
  en: {
    translations: {
      gridHotelFeedback: {
        dashboard: 'Dashboard',
        service_grid: 'Survey and Satisfaction Grids',
        service_grid_single: 'Survey and Satisfaction Grid',
        listed_grids: 'The Survey and Satisfaction Grids are listed below',
        create_service_grid: 'Create Survey and Satisfaction Grid',
        title: 'Title',
        status: 'Status',
        grid_deleted: 'Grid Deleted!',
        grid_deleted_message: 'The Survey and Satisfaction Grid was successfully deleted.',
        error: 'Error',
        error_delete_message: 'An error occurred while deleting the Survey and Satisfaction Grid.',
        service_grid_name: 'Title',
        service_grid_name_placeholder: 'Ex: Satisfaction Survey',
        fill_information_create:
          'Fill in the information below and click the create button to save the changes',
        missing_fields: 'Required fields',
        missing_fields_message: 'The "Title" field and the "Item List" are required!',
        grid_created: 'Grid created',
        grid_created_message: 'Registration completed successfully!',
        error_create_message: 'Error creating the grid!',
        service_list: 'Item List',
        service_placeholder: 'Add an item (Ex: Room Quality)',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: 'Edit Survey and Satisfaction Grid',
        save_changes_edit:
          'Fill in the information below and click the save button to confirm the changes',
        grid_updated: 'Grid changed',
        grid_updated_message: 'Edition completed successfully!',
        error_update_message: 'Error changing the grid!',

        general: {
          actions: 'Actions',
          edit: 'Edit',
          delete: 'Delete',
          active: 'Active',
          inactive: 'Inactive',
          select: 'Select',
          back: 'Back',
        },
        buttons: {
          create: 'Create',
          back: 'Back',
          save: 'Save',
        },
      },
      // Translations for the store language management page
      translate_stores: {
        page_title: 'Store Language and Relationship Management',
        page_subtitle:
          'Manage translation languages and relationships for each store in the system.',
        page_title_relationships: 'Store Relationship Management',
        page_subtitle_relationships: 'Manage the relationships between the stores in the system.',
        tab_translations: 'Manage Languages',
        tab_relations: 'Store Relationships',
        breadcrumb: {
          dashboard: 'Dashboard',
          translate_stores: 'Manage Languages',
        },
        filters: {
          status: 'Status',
          type: 'Type',
          active: 'Active',
          inactive: 'Inactive',
          both: 'Both',
          all_types: 'All',
          status_placeholder: 'Store Status',
          type_placeholder: 'Store Type',
          filter_button: 'Filter',
        },
        status_options: {
          active: 'Active',
          inactive: 'Inactive',
          both: 'Both',
          all_types: 'All',
        },
        languages: {
          portuguese: 'Portuguese',
          spanish: 'Spanish',
          english: 'English',
          french: 'French',
          german: 'German',
          italian: 'Italian',
          japanese: 'Japanese',
          korean: 'Korean',
          chinese: 'Mandarin',
        },
        table: {
          headers: {
            type: 'Type',
            id: 'ID',
            name: 'Name',
            subdomain: 'Subdomain',
            status: 'Status',
            created: 'Created On',
            cnpj: 'CNPJ',
            actions: 'Actions',
          },
          type: 'Type',
          id: 'ID',
          name: 'Name',
          subdomain: 'Subdomain',
          status: {
            active: 'Active',
            inactive: 'Inactive',
          },
          created: 'Created On',
          cnpj: 'CNPJ',
          actions: 'Actions',
        },
        actions: {
          manage_languages: 'Manage Languages',
          edit: 'Edit',
        },
        messages: {
          success: {
            title: 'Success',
            save: 'Languages saved successfully!',
          },
          error: {
            title: 'Error',
            load_data: 'Error loading store data!',
            save_languages: 'Error saving languages!',
          },
        },
        modal: {
          title: 'Manage Languages',
          description: 'Select the languages that will be available for translation in this store:',
          alert: {
            title: 'Attention',
            message:
              'Activate or deactivate the languages that should be used for translation in this store.',
          },
          buttons: {
            cancel: 'Cancel',
            save: 'Save',
          },
        },
        relations: {
          no_relations: 'No relationships found',
          create_title: 'Create Relationship',
          edit_title: 'Edit Relationship',
          parent_label: 'Parent Store',
          child_label: 'Child Store',
          parent_missing: 'Select the parent store',
          child_missing: 'Select the child store',
          same_store_error: 'The parent store cannot be the same as the child store',
          created_success: 'Relationship created successfully',
          updated_success: 'Relationship updated successfully',
          deleted_success: 'Relationship deleted successfully',
          error_create: 'Error creating relationship',
          error_update: 'Error updating relationship',
          error_delete: 'Error deleting relationship',
          store_not_found: 'Store not found',
          all_option: 'All',
          cancel: 'Cancel',
          save: 'Save',
          delete_confirm: 'Yes, delete',
          create_button: 'Create Relationship',
          save_changes: 'Save Changes',
          create_description:
            'Define which store will be the parent store and which will be the child store. A parent store can have multiple child stores and manage their settings.',
          edit_description:
            'Edit the relationship between the selected stores. Changes will be applied immediately.',
          summary_title: 'Relationship Summary:',
          tips_title: 'Important Tips:',
          tip_parent_multiple: 'A parent store can have multiple child stores',
          tip_child_single: 'A child store can have multiple parents',
          tip_all_available: 'All stores (active and inactive) are available for selection',
          click_new: 'Click on "New Relationship" to start',
          message_delete:
            'Are you sure you want to delete this relationship? This action cannot be undone.',
        },
      },
      hospitality_review: {
        page_title: 'Hotel Reviews',
        page_subtitle: 'Manage and monitor hotel guest reviews and ratings.',
        breadcrumb: {
          dashboard: 'Dashboard',
          hospitality: 'Hospitality',
          reviews: 'Reviews',
        },
        statistics: {
          total_reviews: 'Total Reviews',
          average_rating: 'Overall Average',
        },
        filters: {
          filter_by_type: 'Filter by Type',
          filter_by_rating: 'Filter by Rating',
        },
        type_options: {
          all_types: 'All',
          general: 'General',
          room: 'Room',
          food: 'Food',
          service: 'Service',
          cleanliness: 'Cleanliness',
          activities: 'Activities',
        },
        rating_options: {
          all_ratings: 'All ratings',
          five_stars: '5 stars',
          four_stars: '4 stars',
          three_stars: '3 stars',
          two_stars: '2 stars',
          one_star: '1 star',
        },
        table: {
          headers: {
            rating: 'Rating',
            type: 'Type',
            comment: 'Comment',
            date: 'Date',
            actions: 'Actions',
          },
          actions: {
            view_full_review: 'View full review',
          },
          status: {
            approved: 'Approved',
            pending: 'Pending',
          },
        },
        modal: {
          review_title: 'Review from',
          fields: {
            rating: 'Rating',
            type: 'Type',
            status: 'Status',
            date: 'Date',
            comment: 'Comment',
            email: 'Email',
          },
          guest_anonymous: 'Anonymous',
        },
        messages: {
          success: {
            review_deleted: 'Review deleted',
            delete_success: 'Exclusion performed successfully!',
            status_updated: 'Status updated',
            approved_success: 'Review approved successfully!',
            suspended_success: 'Review suspended successfully!',
          },
          error: {
            title: 'Error',
            load_reviews: 'Error loading hotel reviews!',
            invalid_id: 'Invalid ID for exclusion!',
            delete_error: 'Error deleting the review!',
            status_error: 'Error changing review status!',
          },
          confirm: {
            delete_title: 'Confirm exclusion',
            delete_text: 'Are you sure you want to delete this review?',
            delete_confirm: 'Yes, delete',
            delete_cancel: 'Cancel',
          },
        },
      },
      hospitality_info: {
        page_title: 'Hotel Information',
        page_subtitle: 'Manage hotel contact, hours, and services.',
        tabs: {
          contact: 'Contact',
          hours: 'Hours & Information',
          services: 'Services',
          ramal: 'Extension',
          about: 'About',
        },
        contact: {
          phone_label: 'Phone',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: 'E-mail',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: 'Hotel Hours & Information',
          add_button: 'Add Hours/Information',
          remove_button: 'Remove',
          hour_number: 'Item',
          title_label: 'Title',
          title_placeholder: 'E.g.: Reception, Pool, Restaurant',
          description_label: 'Hours & Information',
          description_placeholder:
            'Describe opening hours and additional information (E.g.: 08:00 - 22:00, closed on weekends)',
        },
        services: {
          title: 'Hotel Services',
          add_button: 'Add Service',
          remove_button: 'Remove',
          service_number: 'Service',
          service_title_label: 'Service Title',
          service_title_placeholder: 'Ex: Room Service',
          service_description_label: 'Description',
          service_description_placeholder: 'Describe the service',
        },
        ramal: {
          title: 'Hotel Extension',
          add_button: 'Add Extension',
          remove_button: 'Remove',
          ramal_number: 'Extension',
          ramal_title_label: 'Extension Title',
          ramal_title_placeholder: 'E.g.: 504',
          ramal_description_label: 'Description',
          ramal_description_placeholder: 'Describe the extension',
        },
        about: {
          description_label: 'About the Hotel',
          description_placeholder:
            'Describe general information about the hotel, history, unique features and special characteristics',
        },
        actions: {
          save_button: 'Save',
        },
        messages: {
          error_title: 'Error',
          error_text: 'Could not save hotel information.',
          success_title: 'Saved!',
          success_text: 'Hotel information saved successfully.',
          required_phone: 'Phone is required.',
          required_email: 'Email is required.',
          required_hours: 'All items must have a title and description.',
          required_service: 'All services must have a title and description.',
          required_ramal: 'All extensions must have a title and description.',
        },
      },
      hospitality_schedules: {
        page_title: 'Hotel Schedule',
        page_subtitle: 'Manage hotel events and schedules.',
        new_button: 'New Schedule',
        edit_button: 'Edit Schedule',
        delete_button: 'Delete Schedule',
        delete_confirm:
          'Are you sure you want to delete this schedule? This action cannot be undone.',
        table: {
          title: 'Title',
          type: 'Type',
          location: 'Location',
          time: 'Time',
          recurrence: 'Recurrence',
          period: 'Period',
          status: 'Status',
          actions: 'Actions',
          active: 'Active',
          inactive: 'Inactive',
          single_event: 'Single Event',
          all_types: 'All',
          all_status: 'All statuses',
          age_group: 'Age Group',
        },
        filters: {
          type: 'Type',
          type_placeholder: 'Select type',
          status: 'Status',
          status_placeholder: 'Select status',
          date_init: 'Start Date',
          date_init_placeholder: 'Start date',
          date_end: 'End Date',
          date_end_placeholder: 'End date',
          search: 'Search',
          clear: 'Clear Filters',
        },
        messages: {
          load_error: 'Error loading schedules!',
          delete_success: 'Schedule deleted successfully!',
          delete_error: 'Error deleting the schedule!',
        },
        types: {
          activity: 'Entertainment',
          food: 'Gastronomy',
          event: 'Event',
          tour: 'Tour',
        },
        age_groups: {
          all: 'All',
          children: 'Children',
          teens: 'Teens',
          adults: 'Adults',
          seniors: 'Seniors',
          family: 'Family',
        },
        singleEvent: 'Single Event',
      },
      hospitality_schedule_edit: {
        page_title: 'Edit Schedule',
        page_subtitle: 'Editing: {{title}}',
        not_found: {
          title: 'Schedule not found',
          description: 'The schedule you are trying to edit was not found.',
          back_button: 'Back to List',
        },
        form: {
          type_label: 'Type',
          type_placeholder: 'Select type',
          type_sports: 'Sports',
          type_wellness: 'Wellness',
          type_other: 'Other',
          title_label: 'Title',
          title_placeholder: 'Enter the schedule title',
          description_label: 'Description',
          description_placeholder: 'Describe the schedule',
          location_label: 'Location',
          location_placeholder: 'Schedule location',
          time_label: 'Time',
          time_placeholder: 'Ex: 14:00 - 16:00 or 14:00',
          time_smalltext: 'Format: "HH:MM - HH:MM" or "HH:MM"',
          recurrence_config: 'Recurrence Configuration',
          single_event_radio: 'Single Event - Event that happens on specific dates',
          recurring_event_radio:
            'Recurring Event - Event that repeats on specific days of the week',
          day_within_date_range_radio:
            'Event within a Date Range - Event that occurs within a specific date range',
          days_of_week_label: 'Days of the Week',
          selected_days: 'Selected: {{days}}',
          date_init_label: 'Start Date',
          date_init_placeholder: 'Start date',
          date_end_label: 'End Date',
          date_end_placeholder: 'End date (optional)',
          status_label: 'Status',
          back_button: 'Back',
          save_button: 'Save Changes',
        },
      },
      hospitality_schedule_create: {
        page_title: 'New Schedule',
        page_subtitle: 'Create a new schedule for the hotel',
        success: {
          title: 'Success!',
          text: 'Schedule created successfully!',
        },
        error: {
          title: 'Error',
          text: 'Error creating schedule!',
        },
        form: {
          title_label: 'Title *',
          title_placeholder: 'Enter the schedule title',
          title_required: 'Title is mandatory',
          type_label: 'Type *',
          type_placeholder: 'Select type',
          type_sports: 'Sports',
          type_wellness: 'Wellness',
          type_other: 'Others',
          description_label: 'Description *',
          description_placeholder: 'Describe the schedule',
          description_required: 'Description is mandatory',
          location_label: 'Location *',
          location_placeholder: 'Schedule location',
          location_required: 'Location is mandatory',
          time_label: 'Time *',
          time_placeholder: 'Ex: 14:00 - 16:00 or 14:00',
          time_smalltext: 'Format: "HH:MM - HH:MM" or "HH:MM"',
          time_required: 'Time is mandatory',
          recurrence_config: 'Recurrence Configuration',
          single_event_radio: 'Single Event - Event that happens on specific dates',
          recurring_event_radio:
            'Recurring Event - Event that repeats on specific days of the week',
          day_within_date_range_radio:
            'Event within a Date Range - Event that occurs within a specific date range',
          days_of_week_label: 'Days of the Week',
          selected_days: 'Selected: {{days}}',
          date_init_label: 'Start Date',
          date_init_placeholder: 'Start date',
          date_end_label: 'End Date',
          date_end_placeholder: 'End date (optional)',
          status_label: 'Status',
          back_button: 'Back',
          save_button: 'Save',
        },
      },
      hospitality_banner: {
        page_title: 'Hotel Banners',
        page_subtitle: 'Manage your hotel banners. Control display period, order, and status.',
        breadcrumb: {
          hospitality: 'Hospitality',
          publicity: 'Publicity',
        },
        new_button: 'New Publicity',
        table: {
          title: 'Title',
          image: 'Image',
          order: 'Order',
          period: 'Period',
          created_date: 'Creation Date',
          status: 'Status',
          actions: 'Actions',
        },
        actions: {
          edit: 'Edit publicity',
          view: 'View details',
          delete: 'Delete publicity',
        },
        modal: {
          title: 'Publicity #{{id}}',
          order: 'Order',
          status: 'Status',
          active: 'Active',
          inactive: 'Inactive',
          period: 'Period',
          created: 'Created On',
          updated: 'Last updated',
          image: 'Image',
          no_image: 'No image',
        },
        delete: {
          confirm_title: 'Confirm exclusion',
          confirm_text: 'Are you sure you want to delete this publicity?',
          confirm_button: 'Yes, delete',
          cancel_button: 'Cancel',
          success_title: 'Publicity deleted',
          success_text: 'Exclusion performed successfully!',
        },
        status: {
          success_title: 'Status updated',
          success_text: 'Publicity {{action}} successfully!',
          activated: 'activated',
          deactivated: 'deactivated',
        },
        error: {
          title: 'Error',
          load_data: 'Error loading publicity data!',
          invalid_id: 'Invalid ID for exclusion!',
          delete: 'Error deleting the publicity!',
          status_change: 'Error changing publicity status!',
        },
      },
      hospitality_banner_create: {
        page_title: 'Create New Hotel Banner',
        page_subtitle: 'Fill in the information below to create a new banner.',
        breadcrumb: {
          hospitality: 'Hospitality',
          publicity: 'Publicity',
          create: 'Create Publicity',
        },
        form: {
          title_label: 'Banner Title *',
          title_placeholder: 'Ex: Hikes...',
          order_label: 'Display Order *',
          order_placeholder: 'Ex: 1, 2, 3...',
          order_smalltext: 'Publicity priority order (smaller numbers appear first)',
          status_label: 'Active Publicity',
          status_smalltext: 'Check to activate the publicity',
          start_date_label: 'Start Date *',
          start_time_label: 'Start Time *',
          end_date_label: 'End Date *',
          end_time_label: 'End Time *',
          image_label: 'Publicity Image',
          image_select: 'Select an image',
          image_formats: 'Accepted formats: JPG, PNG, GIF',
          image_optional: 'Optional - A default image will be used if not provided',
          image_preview: 'Image Preview',
          image_remove: 'Remove Image',
        },
        preview: {
          period_title: 'Publicity Period:',
          start: 'Start',
          end: 'End',
        },
        validation: {
          title: 'Validation Error',
          order_positive: 'Order must be a number greater than zero!',
          start_date_required: 'Start date is mandatory!',
          end_date_required: 'End date is mandatory!',
          dates_required: 'Dates and times are mandatory!',
          start_before_end: 'Start date must be before end date!',
        },
        success: {
          title: 'Publicity created',
          text: 'Publicity created successfully!',
        },
        error: {
          title: 'Error',
          text: 'Error creating the publicity!',
        },
      },
      hospitality_banner_update: {
        page_title: 'Edit Hotel Publicity',
        page_subtitle: 'Editing publicity #{{id}}',
        breadcrumb: {
          edit: 'Edit Publicity',
        },
        current_image: 'Current Image',
        save_button: 'Save Changes',
        not_found: {
          title: 'Publicity not found',
          text: 'The publicity you are trying to edit was not found.',
          back_button: 'Back to List',
        },
        no_changes: {
          title: 'No changes',
          text: 'No fields were modified!',
        },
        success: {
          title: 'Publicity updated',
          text: 'Publicity updated successfully!',
        },
        error: {
          title: 'Error',
          text: 'Error updating publicity',
          load_data: 'Error loading publicity data!',
          update: 'Error updating the publicity!',
        },
      },
      hospitality_publicity: {
        page_title: 'Hotel Highlight Banners',
        page_subtitle:
          'Manage your hotel highlight banners. Control display period, order, and status.',
        breadcrumb: {
          hospitality: 'Hospitality',
          publicity: 'Publicity',
        },
        new_button: 'New Banner',
        table: {
          image: 'Image',
          order: 'Order',
          period: 'Period',
          created_date: 'Creation Date',
          status: 'Status',
          actions: 'Actions',
        },
        actions: {
          edit: 'Edit publicity',
          view: 'View details',
          delete: 'Delete publicity',
        },
        modal: {
          title: 'Publicity #{{id}}',
          order: 'Order',
          status: 'Status',
          active: 'Active',
          inactive: 'Inactive',
          period: 'Period',
          created: 'Created On',
          updated: 'Last updated',
          image: 'Image',
          no_image: 'No image',
        },
        delete: {
          confirm_title: 'Confirm exclusion',
          confirm_text: 'Are you sure you want to delete this publicity?',
          confirm_button: 'Yes, delete',
          cancel_button: 'Cancel',
          success_title: 'Publicity deleted',
          success_text: 'Exclusion performed successfully!',
        },
        status: {
          success_title: 'Status updated',
          success_text: 'Publicity {{action}} successfully!',
          activated: 'activated',
          deactivated: 'deactivated',
        },
        error: {
          title: 'Error',
          load_data: 'Error loading publicity data!',
          invalid_id: 'Invalid ID for exclusion!',
          delete: 'Error deleting the publicity!',
          status_change: 'Error changing publicity status!',
        },
      },
      hospitality_publicity_create: {
        page_title: 'Create Hotel Publicity',
        page_title_edit: 'Edit Hotel Publicity',
        page_subtitle: 'Fill in the information below to create a new publicity.',
        breadcrumb: {
          hospitality: 'Hospitality',
          publicity: 'Publicity',
          create: 'Create Publicity',
        },
        form: {
          order_label: 'Display Order *',
          order_placeholder: 'Ex: 1, 2, 3...',
          order_smalltext: 'Publicity priority order (smaller numbers appear first)',
          status_label: 'Active Publicity',
          status_smalltext: 'Check to activate the publicity',
          start_date_label: 'Start Date *',
          start_time_label: 'Start Time *',
          end_date_label: 'End Date *',
          end_time_label: 'End Time *',
          image_label: 'Publicity Image',
          image_select: 'Select an image',
          image_formats: 'Accepted formats: JPG, PNG, GIF | Dimensions: ~200x112px | Max size: 2MB',
          image_optional: 'Optional - A default image will be used if not provided',
          image_preview: 'Image Preview',
          image_remove: 'Remove Image',
          external_link_checkbox: 'Include External Link',
          external_link_label: 'External Link',
          external_link_placeholder: 'https://example.com',
          description_label: 'Banner Description',
          description_smalltext: '* Maximum {qtd} characters',
          title_label: 'Banner Title',
          title_placeholder: 'Example: Hiking...',
          title_smalltext: '* Maximum {qtd} characters',
        },
        preview: {
          period_title: 'Publicity Period:',
          start: 'Start',
          end: 'End',
        },
        validation: {
          title: 'Validation Error',
          order_positive: 'Order must be a number greater than zero!',
          start_date_required: 'Start date is mandatory!',
          end_date_required: 'End date is mandatory!',
          dates_required: 'Dates and times are mandatory!',
          start_before_end: 'Start date must be before end date!',
          external_link_required: 'External link is mandatory when the option is selected!',
          image_size_error: 'Image must have a maximum size of 2MB!',
          image_dimensions_error:
            'Image dimensions should be approximately 200x112 pixels! Current: {{current}}',
          image_invalid: 'Invalid image file! Please select a valid image.',
        },
        success: {
          title: 'Publicity created',
          text: 'Publicity created successfully!',
        },
        error: {
          title: 'Error',
          text: 'Error creating the publicity!',
          update: 'Error updating the publicity!',
        },
        not_found: {
          title: 'Advertisement not found',
          text: 'The advertisement you are trying to edit was not found.',
          back_button: 'Back to List',
        },
        no_changes: {
          title: 'No changes',
          text: 'No fields were modified!',
        },
        current_image: 'Current Image',
      },
      // Adicionar ao arquivo
      service_list: {
        filters: {
          categories: 'Categories',
          category_placeholder: 'Category',
          filter_button: 'Filter',
          all_categories: 'ALL',
        },
        table: {
          schedule: 'Schedule',
          extension: 'Extension',
        },
        actions: {
          delete_service: 'Delete Service',
        },
      },
      // Adicionar ao arquivo
      service_create: {
        page_title: 'Register Service',
        breadcrumb: {
          services: 'Services',
          create: 'Create',
        },
        form: {
          classification_placeholder: 'Select a classification',
          name_label: 'Name',
          name_placeholder: 'Service name',
          description_label: 'Description',
          description_placeholder: 'Service description',
          schedule_label: 'Operating Hours',
          schedule_placeholder: 'Ex: 24h, 08:00-18:00, On demand',
          schedule_smalltext: 'Maximum 50 characters',
          extension_label: 'Extension',
          extension_placeholder: 'Ex: 1001, 2050',
          extension_smalltext: 'Maximum 10 characters',
          code_label: 'Code',
          code_placeholder: 'Service code',
          order_label: 'Order',
          order_placeholder: 'Display order',
          status_label: 'Status',
          status_active: 'Active',
          status_inactive: 'Inactive',
          external_link_label: 'External Link',
          external_link_placeholder: 'https://example.com',
          priority_label: 'Priority',
          priority_low: 'Low',
          priority_normal: 'Normal',
          priority_high: 'High',
          priority_critical: 'Critical',
        },
        icons: {
          title: 'Icons',
          category_label: 'Icon Category',
          all_categories: 'All',
          selected_icon: 'Selected icon',
        },
        validation: {
          missing_fields_title: 'Missing fields',
          missing_fields_text:
            'Check if you filled in all mandatory fields: Name, Classification and Icon!',
        },
        success: {
          title: 'Service registered',
          text: 'Registration successful!',
        },
        error: {
          title: 'Error',
          text: 'Error registering the service!',
          icons_load: 'Error finding types',
        },
      }, // Adicionar ao arquivo
      service_update: {
        page_title: 'Edit Service',
        page_title_full: 'Update Service',
        breadcrumb: {
          edit: 'Edit',
        },
        error: {
          title: 'Error',
          load_data: 'Error loading service data!',
          text: 'Error updating the service!',
        },
        success: {
          title: 'Service updated',
          text: 'Edition performed successfully!',
        },
      },
      // Adicionar ao arquivo
      service_category_create: {
        validation: {
          missing_fields_title: 'Missing fields',
          missing_fields_text: 'Check if you filled in all fields!',
        },
        success: {
          title: 'Classification registered',
          text: 'Registration successful!',
        },
        error: {
          title: 'Error',
          text: 'Error registering the classification!',
          create: 'Error registering classification!',
        },
      },

      // Adicionar ao arquivo
      service_category_list: {
        page_title: 'Content Categories',
        page_subtitle:
          'Here are the content categories listed along with their respective actions.',
        breadcrumb: {
          categories: 'Categories',
        },
        add_button: 'Add',
        table: {
          name: 'Name',
          status: 'Status',
          actions: 'Actions',
        },
        actions: {
          edit_category: 'Edit category',
          delete_category: 'Delete category',
        },
        delete: {
          error_title: 'Error',
          error_text: 'Error deleting the category!',
          success_title: 'Category deleted',
          success_text: 'Deletion performed successfully!',
          confirm_title: 'Are you sure?',
          confirm_text: 'The category will be deleted and cannot be restored!',
          cancel_button: 'Close!',
          confirm_button: 'Delete!',
        },
      },
      service_category_update: {
        error: {
          title: 'Error',
          load_data: 'Error loading classification data!',
          text: 'Error updating the classification!',
          update: 'Error updating the classification!',
        },
        success: {
          title: 'Classification updated',
          text: 'Edition performed successfully!',
        },
      },
      hotelRoom: {
        status: {
          available: 'Available',
          reserved: 'Reserved',
          maintenance: 'Under Maintenance',
          occupied: 'Occupied',
          being_cleaning: 'Being Cleaned',
        },
        type: {
          single: 'Single',
          double: 'Double',
          twin: 'Twin',
          queen: 'Queen',
          king: 'King',
          suite: 'Suite',
          junior_suite: 'Junior Suite',
          master_suite: 'Master Suite',
          presidential: 'Presidential Suite',
          family: 'Family Room',
          accessible: 'Accessible Room',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: 'Customer',
          wizard_step_reservation: 'Reservation',
          wizard_step_confirmation: 'Confirmation',
          wizard_step1: 'Step 1',
          wizard_step2: 'Step 2',
          wizard_step3: 'Step 3',
          wizard_customer_title: 'Select or Register Customer',
          wizard_customer_search_placeholder: 'Search by name, email or phone...',
          wizard_customer_search_button: 'Search Existing Customer',
          wizard_customer_new_button: 'Register New Customer',
          wizard_customer_none_found: 'No customer found',
          wizard_customer_showing_first:
            'Showing the first 20 results. Refine your search to find other customers.',
          wizard_reservation_title: 'Reservation Data',
          wizard_reservation_room_label: 'Room *',
          wizard_reservation_room_subtitle:
            'Click on the rooms to select them. You can select multiple rooms.',
          wizard_reservation_room_placeholder: 'Select a room',
          wizard_reservation_status_label: 'Reservation Status',
          wizard_reservation_status_placeholder: 'Select status',
          wizard_reservation_checkin_label: 'Check-in Date and Time *',
          wizard_reservation_checkout_label: 'Check-out Date and Time *',
          wizard_reservation_password_label: 'Customer Password',
          wizard_reservation_password_placeholder: 'Enter customer password',
          wizard_reservation_generate_password: 'Generate password',
          wizard_confirmation_title: 'Confirm Reservation',
          wizard_confirmation_customer_data: 'Customer Data',
          wizard_confirmation_reservation_data: 'Reservation Data',
          wizard_confirmation_room: 'Room',
          wizard_confirmation_capacity: 'Capacity',
          wizard_confirmation_price: 'Price',
          wizard_confirmation_checkin: 'Check-in',
          wizard_confirmation_checkout: 'Check-out',
          wizard_confirmation_status: 'Status',
          wizard_confirmation_password: 'Password',
          wizard_confirmation_address: 'Address',
          wizard_confirmation_zipcode: 'Zip Code',
          wizard_confirmation_gender_male: 'Male',
          wizard_confirmation_gender_female: 'Female',
          wizard_confirmation_gender_other: 'Other',
          wizard_confirmation_gender_not_informed: 'Prefer not to inform',
          wizard_buttons_back: 'Back',
          wizard_buttons_cancel: 'Cancel',
          wizard_buttons_next: 'Next',
          wizard_buttons_create: 'Create',
          wizard_page_title: 'New Room Reservation',
          wizard_page_subtitle: 'Create new reservation for the hotel',
          legend: {
            title: 'Legend',
            available: 'Available',
            selected: 'Selected',
            unavailable: 'Unavailable',
            occupied: 'Occupied',
            reserved: 'Reserved',
            being_cleaning: 'Cleaning in Progress',
            maintenance: 'Under Maintenance',
            no_info: 'No Information',
          },
        },
        customer_form: {
          title: 'Customer Data',
          personal_info_title: 'Personal Information',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: 'Full Name *',
          name_placeholder: 'Enter full name',
          email_label: 'E-mail *',
          email_placeholder: 'Enter e-mail',
          birthdate_label: 'Date of Birth *',
          gender_label: 'Gender',
          gender_placeholder: 'Select gender',
          gender_male: 'Male',
          gender_female: 'Female',
          gender_other: 'Other',
          contact_info_title: 'Contact Information',
          phone_label: 'Phone *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: 'Phone Type',
          phone_type_cell: 'Cell Phone',
          phone_type_landline: 'Landline',
          whatsapp_optin: 'Accepts receiving messages on WhatsApp',
          address_title: 'Residential Address',
          cep_label: 'Zip Code *',
          cep_placeholder: '00000-000',
          street_label: 'Street *',
          street_placeholder: 'Street, Avenue, etc.',
          number_label: 'Number *',
          number_placeholder: '123',
          extra_label: 'Complement',
          extra_placeholder: 'Apartment, Block, etc.',
          district_label: 'Neighborhood *',
          district_placeholder: 'Neighborhood name',
          city_label: 'City *',
          city_placeholder: 'City name',
          state_label: 'State *',
          state_placeholder: 'SP',
          reference_label: 'Reference Point',
          reference_placeholder: 'Near the mall, across from the square, etc.',
          terms_title: 'Terms and Conditions',
          accept_terms: 'I accept the terms and conditions of use *',
          lgpd_consent: 'I authorize the processing of my personal data (LGPD) *',
        },
        title: 'Room Reservations',
        subtitle: 'Hotel reservation management',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_reservation: 'Reservations',
        btn_new_reservation: 'New Reservation',
        btn_confirm: 'Confirm Reservation',
        btn_checkin: 'Perform Check-in',
        btn_checkout: 'Perform Check-out',
        btn_cancel: 'Cancel Reservation',
        btn_no_show: 'Mark as No Show',
        btn_delete: 'Delete Reservation',
        btn_details: 'Reservation Details',
        filter_status_label: 'Reservation Status',
        filter_status_placeholder: 'Select a status',
        filter_status_all: 'All Status',
        table_reservation: 'Reservation',
        table_room: 'Room',
        table_customer: 'Customer',
        table_checkin: 'Check-in',
        table_checkout: 'Check-out',
        table_status: 'Status',
        table_price: 'Value',
        table_actions: 'Actions',
        status_confirmed: 'Confirmed',
        status_in_progress: 'In Progress',
        status_completed: 'Completed',
        status_cancelled: 'Cancelled',
        status_no_show: 'No Show',
        status_pending: 'Pending',
        msg_success_delete: 'Deletion performed successfully!',
        msg_success_update: 'Reservation status updated successfully!',
        msg_error_delete: 'Error deleting the reservation!',
        msg_error_update: 'Error updating reservation status!',
        msg_confirm_status_change: 'Do you want to change the reservation status to "{status}"?',
        msg_confirm_checkin: 'Do you want to check-in for this reservation?',
        msg_confirm_checkout:
          'Do you want to finalize the check-out? This action cannot be undone.',
        msg_checkout_attention: '⚠️ ATTENTION - READ CAREFULLY:',
        msg_checkout_list: [
          'The customer has already made the payment',
          'There are no pending financial issues',
          'All services have been duly settled',
        ],
        msg_checkout_confirm_read: 'I have read and confirm that all validations have been checked',
        msg_checkout_validation:
          'You must confirm that you have read and checked all validations before proceeding.',
        msg_confirm_delete: 'Delete Reservation',
        tab_basic: 'Basic Information',
        tab_summary: 'Summary',
        tab_activities: 'Activities',
        tab_tours: 'Tours',
        tab_experiences: 'Experiences',
        tab_services: 'Service Reservations',
        tab_services_list: 'Service Listing',
        tab_orders: 'Hotel Orders',
        label_loading: 'Loading...',
        label_loading_orders: 'Loading orders...',
        label_order_details: 'Order Details',
        label_no_data: 'No order found',
        label_pending: 'No order is reserved at the moment.',
        tab_title: 'Hotel Orders',
        label_order: 'Order',
        label_orders: 'Orders',
        label_total_spent: 'Total Spent: {value}',
        label_total_orders: 'Total Orders',
        label_total_spent_label: 'Total Spent',
        label_total_paid_label: 'Total Paid',
        label_products: 'Products',
        label_quantity: 'Quantity',
        label_sku: 'SKU',
        label_delivery: 'Delivery',
        label_delivery_address: 'Delivery Address',
        label_withdraw_address: 'Pickup Address',
        label_financial_summary: 'Financial Summary',
        label_products_label: 'Products',
        label_delivery_fee: 'Delivery Fee',
        label_discount: 'Discount',
        label_total: 'Total',
        label_payment_na: 'Payment N/A',
        label_payment_offline: 'Offline Payment',
        label_payment_card: 'Card Payment',
        label_payment_credit: 'Credit',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: 'Basic Information',
          label_customer: 'Customer',
          label_room: 'Room',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Status',
          label_price: 'Value',
          label_notes: 'Observations',
          placeholder_notes: 'Add reservation observations',
          status_edit_warning:
            'Reservation status cannot be edited after confirmation or cancellation.',
          selected_room_details: 'Room {roomNumber} - {type} (Capacity: {capacity}) - R$ {price}',
          selected_customer_details: 'Customer: {name} | Email: {email} | Phone: {phone}',
          optional_checkout: 'Check-out is optional and can be filled in later.',
          status_pending: 'Pending',
          status_confirmed: 'Confirmed',
          status_in_progress: 'In Progress',
          status_completed: 'Completed',
          status_cancelled: 'Cancelled',
          summary_capacity: 'Capacity',
          summary_people: 'people',
          btn_change_password: 'Change Password',
        },
        summary: {
          tab_title: 'Summary',
          room_details: 'Room Details',
          label_total: 'Total',
          label_paid: 'Paid',
          label_pending: 'Pending',
          label_services: 'Services',
          label_products: 'Products',
          label_activities: 'Activities',
          label_experiences: 'Experiences',
          label_tours: 'Tours',
          label_room: 'Room',
          label_customer: 'Customer',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Status',
          label_price: 'Value',
          label_notes: 'Observations',
          label_capacity: 'Capacity',
          label_people: 'People',
          label_orders: 'Hotel Orders',
          label_payment_method: 'Payment Method',
          label_discount: 'Discount',
          label_tax: 'Tax',
          label_total_with_tax: 'Total with Tax',
          label_total_with_discount: 'Total with Discount',
          label_total_paid: 'Total Paid',
          label_total_pending: 'Total Pending',
          label_summary: 'Reservation Summary',
          label_details: 'Details',
          label_edit: 'Edit',
          label_delete: 'Delete',
          label_confirm: 'Confirm',
          label_cancel: 'Cancel',
          label_no_data: 'No data available',
          label_success: 'Operation performed successfully!',
          label_error: 'Error in operation!',
          label_warning: 'Attention',
          label_info: 'Information',
          label_actions: 'Actions',
          label_service: 'Service',
          label_product: 'Product',
          label_activity: 'Activity',
          label_experience: 'Experience',
          label_tour: 'Tour',
          label_order: 'Order',
          label_date: 'Date',
          label_time: 'Time',
          label_type: 'Type',
          label_edit_reservation: 'Edit Reservation',
          label_delete_reservation: 'Delete Reservation',
          label_confirm_reservation: 'Confirm Reservation',
          label_cancel_reservation: 'Cancel Reservation',
          label_status_confirmed: 'Confirmed',
          label_status_in_progress: 'In Progress',
          label_status_completed: 'Completed',
          label_status_cancelled: 'Cancelled',
          label_status_no_show: 'No Show',
          label_status_pending: 'Pending',
        },
        activities: {
          tab_title: 'Activities',
          label_activity: 'Activity',
          label_activities: 'Activities',
          label_no_data: 'No activity found',
          label_pending: 'No activity is reserved at the moment.',
          label_people: 'Participants',
          label_category: 'Category',
          label_location: 'Location',
          label_session_time: 'Session Time',
          label_skill_level: 'Skill Level',
          label_special_requests: 'Special Requests',
          label_price: 'Value',
          label_date: 'Date',
          label_time: 'Time',
          label_status: 'Status',
          label_actions: 'Actions',
          label_description: 'Description',
          status_confirmed: 'Confirmed',
          status_pending: 'Pending',
          status_cancelled: 'Cancelled',
          status_completed: 'Completed',
          btn_add_activity: 'Add Activity',
        },
        experiences: {
          tab_title: 'Experiences',
          label_experience: 'Experience',
          label_experiences: 'Experiences',
          label_no_data: 'No experience found',
          label_pending: 'No experience is reserved at the moment.',
          label_people: 'Participants',
          label_category: 'Category',
          label_location: 'Location',
          label_session_time: 'Session Time',
          label_skill_level: 'Skill Level',
          label_special_requests: 'Special Requests',
          label_price: 'Value',
          label_date: 'Date',
          label_time: 'Time',
          label_status: 'Status',
          label_actions: 'Actions',
          label_description: 'Description',
          status_confirmed: 'Confirmed',
          status_pending: 'Pending',
          status_cancelled: 'Cancelled',
          status_completed: 'Completed',
          btn_add_experience: 'Add Experience',
          label_duration: 'Duration',
          label_rating: 'Rating',
          label_special_occasion: 'Special Occasion',
          label_includes: 'Includes',
        },
        hotel_orders: {
          tab_title: 'Hotel Orders',
          label_order: 'Order',
          label_orders: 'Orders',
          label_no_data: 'No order found',
          label_pending: 'No order is reserved at the moment.',
          label_delivery: 'Delivery',
          label_quantity: 'Quantity',
          label_sku: 'SKU',
          label_delivery_address: 'Delivery Address',
          label_withdraw_address: 'Pickup Address',
          label_financial_summary: 'Financial Summary',
          label_products: 'Products',
          label_products_label: 'Products',
          label_total_spent: 'Total Spent: {value}',
          label_total_orders: 'Total Orders',
          label_total_spent_label: 'Total Spent',
          label_total_paid_label: 'Total Paid',
          label_discount: 'Discount',
          label_total: 'Total',
          label_payment_na: 'Payment N/A',
          label_payment_offline: 'Offline Payment',
          label_payment_card: 'Card Payment',
          label_payment_credit: 'Credit',
          label_delivery_fee: 'Delivery Fee',
          no_order_title: 'No Order Found',
        },
        tours: {
          tab_title: 'Tours',
          label_tour: 'Tour',
          label_tours: 'Tours',
          label_no_data: 'No tour found',
          label_pending: 'No tour is reserved at the moment.',
          label_people: 'Participants',
          label_duration: 'Duration',
          label_difficulty: 'Difficulty',
          label_rating: 'Rating',
          label_transfer_included: 'Transfer Included',
          label_transfer_yes: 'Transfer Included',
          label_transfer_no: 'No Transfer',
          label_schedule: 'Schedule',
          label_weather_concerns: 'Weather Concerns',
          label_physical_requirements: 'Physical Requirements',
          label_special_requests: 'Special Requests',
          label_price: 'Value',
          label_date: 'Date',
          label_time: 'Time',
          label_status: 'Status',
          label_actions: 'Actions',
          label_description: 'Description',
          status_confirmed: 'Confirmed',
          status_pending: 'Pending',
          status_cancelled: 'Cancelled',
          status_completed: 'Completed',
          btn_add_tour: 'Add Tour',
        },
        services: {
          tab_title: 'Services',
          no_services: 'No services booked',
          no_services_description: 'There are no services booked for this stay at the moment.',
          total_services: 'Total Services',
          total_amount: 'Total Amount',
          total_people: 'Total People',
          service_info: 'Service Information',
          service_name: 'Service Name',
          booking_id: 'Booking ID',
          reservation_date: 'Reservation Date',
          reservation_time: 'Time',
          people_qty: 'Number of People',
          submitted_at: 'Submitted at',
          room_info: 'Room Information',
          room_number: 'Room Number',
          room_type: 'Room Type',
          room_price: 'Room Price',
          total_price: 'Total Price',
          description: 'Description',
          booking_details: 'Booking Details',
          booking_title: 'Title',
          capacity: 'Capacity',
          multiple: 'Multiple',
          yes: 'Yes',
          no: 'No',
          notes: 'Notes',
          created_at: 'Created at',
          updated_at: 'Updated at',
          service_id: 'Service',
          status_confirmed: 'Confirmed',
          status_pending: 'Pending',
          status_cancelled: 'Cancelled',
          status_completed: 'Completed',
        },
        services_list: {
          tab_title: 'Service Listing',
          no_services: 'No services booked',
          no_services_description: 'There are no services booked for this stay at the moment.',
          total_filtered: 'Filtered Services',
          of_total: 'of {total}',
          total_amount: 'Total Amount',
          total_people: 'Total People',
          average_price: 'Average Price',
          filter_search: 'Search',
          filter_search_placeholder: 'Search by name, room, description...',
          filter_status: 'Status',
          filter_status_all: 'All Statuses',
          active_filters: 'Active Filters',
          clear_filters: 'Clear Filters',
          table_title: 'List of Booked Services',
          services: 'services',
          column_id: 'ID',
          column_service: 'Service',
          column_room: 'Room',
          column_date: 'Date',
          column_people: 'People',
          column_price: 'Price',
          column_status: 'Status',
          column_actions: 'Actions',
          btn_view_details: 'View Details',
          no_results: 'No results found',
          no_results_description: 'Try adjusting the filters to find more results.',
          status_confirmed: 'Confirmed',
          status_pending: 'Pending',
          status_cancelled: 'Cancelled',
          status_completed: 'Completed',
          showing: 'Showing',
          to: 'to',
          of: 'of',
        },
      },
      hospitality_hotel_room: {
        label_room_number: 'Room Number *',
        image: 'Room Image',
        placeholder_room_number: 'Ex: 101, A201, Presidential Suite',
        max_20_chars: 'Maximum 20 characters',
        label_status: 'Status',
        label_capacity: 'Capacity (people)',
        placeholder_capacity: 'Ex: 2',
        label_price: 'Price (R$)',
        placeholder_price: 'Ex: 150.00',
        label_type: 'Room Type',
        title: 'Hotel Rooms',
        subtitle: 'Hotel room management',
        create_multiples: 'Create Multiple Rooms',
        add_room: 'Add Room',
        header_number: 'Number',
        header_status: 'Status',
        header_type: 'Type',
        header_capacity: 'Capacity',
        header_price: 'Price',
        header_actions: 'Actions',
        action_edit: 'Edit Room',
        action_delete: 'Delete Room',
        modal_bulk_title: 'Create Multiple Rooms',
        modal_bulk_prefix: 'Prefix (optional)',
        modal_bulk_prefix_placeholder: 'Ex: A, B, 1st',
        modal_bulk_start: 'Initial Number *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: 'Final Number *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: 'Capacity',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: 'Price',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: 'Type',
        type_single: 'Single',
        type_double: 'Double',
        type_twin: 'Twin',
        type_queen: 'Queen',
        type_king: 'King',
        type_suite: 'Suite',
        type_junior_suite: 'Junior Suite',
        type_master_suite: 'Master Suite',
        type_presidential: 'Presidential',
        type_family: 'Family',
        type_accessible: 'Accessible',
        modal_bulk_cancel: 'Cancel',
        modal_bulk_create: 'Create Rooms',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hotel_room: 'Hotel Rooms',
        create_title: 'Create Hotel Room',
        create_subtitle: 'Add new room to the hotel',
        edit_title: 'Edit Hotel Room',
        edit_subtitle: 'Edit room #{room} information',
        breadcrumb_create: 'Create Room',
        breadcrumb_edit: 'Edit Room',
      },
      hospitality_experiences: {
        tab_basic: 'Basic Information',
        edit: 'Edit Experience',
        edit_subtitle: 'Update experience information',
        create: 'Create Experience',
        create_subtitle: 'Fill in the details to create a new experience',
        tab_details: 'Detailed Items',
        tab_image: 'Image',
        tab_schedules: 'Schedules',
        list_title: 'Hotel Experiences',
        list_subtitle: 'Manage all hotel experiences',
        field_title: 'Title',
        field_title_placeholder: 'Ex: Exclusive Romantic Dinner',
        field_description: 'Description',
        field_description_placeholder: 'Describe the offered experience in detail...',
        field_image: 'New Image',
        field_price: 'Price (R$)',
        field_price_placeholder: '0.00',
        field_duration: 'Duration',
        field_duration_placeholder: 'Ex: 2 hours',
        field_type: 'Experience Type',
        field_rating: 'Rating (0-5)',
        field_rating_placeholder: '0',
        field_status: 'Active Status',
        field_includes: 'Included Items',
        field_includes_placeholder: 'Ex: Champagne, special decoration...',
        field_show_additional_services: 'Show pre-defined service options',
        field_actions: 'Actions',
        status_active: 'Active',
        status_inactive: 'Inactive',
        no_rating: 'No rating',
        no_includes: 'No items included',
        currency: 'R$',
        btn_add: 'Add Experience',
        btn_edit: 'Edit',
        btn_delete: 'Remove',
        btn_update: 'Update Experience',
        btn_create: 'Create Experience',
        btn_remove: 'Remove',
        btn_add_item: 'Add Item',
        edit_title: 'Edit Experience',
        create_title: 'Create Experience',
        msg_success_create: 'Experience created successfully!',
        msg_success_update: 'Experience updated successfully!',
        msg_success_delete: 'Experience removed',
        msg_success_delete_text: 'Experience removed successfully!',
        msg_error_create: 'Error creating experience',
        msg_error_update: 'Error updating experience',
        msg_error_delete: 'Error removing experience',
        msg_error_delete_text: 'Could not remove experience!',
        msg_error_load: 'Error loading experience',
        msg_error_load_text: 'Could not load experience data!',
        msg_error_required_title: 'Title is mandatory!',
        msg_error_title_length: 'Title must have a maximum of 255 characters!',
        msg_error_required_description: 'Description is mandatory!',
        msg_error_required_price: 'Price is mandatory!',
        msg_error_price_negative: 'Price must be greater than or equal to zero!',
        msg_error_required_duration: 'Duration is mandatory!',
        msg_error_duration_length: 'Duration must have a maximum of 100 characters!',
        msg_error_required_includes: 'At least one item must be included!',
        msg_error_rating_range: 'Rating must be between 0 and 5!',
        field_order: 'Order',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        header_order: 'Order',
        msg_error_order_negative: 'The order must be greater than or equal to zero!',
      },
      entertainment_services: {
        list_title: 'Entertainment Services',
        list_subtitle: 'Manage available entertainment services',
        create: 'Create Entertainment Service',
        create_subtitle: 'Fill in the details to create a new service',
        create_title: 'Create Entertainment Service',
        edit: 'Edit Entertainment Service',
        edit_subtitle: 'Update the service information',
        edit_title: 'Edit Entertainment Service',
        field_title: 'Title',
        field_title_placeholder: 'Ex: Spa and Massage',
        field_type: 'Service Type',
        field_status: 'Active Status',
        field_actions: 'Actions',
        type_experience: 'Entertainment Experience',
        type_activity: 'Entertainment Activity',
        type_tour: 'Entertainment Tour',
        status_active: 'Active',
        status_inactive: 'Inactive',
        btn_add: 'Add Service',
        btn_edit: 'Edit',
        btn_delete: 'Remove',
        btn_update: 'Update Service',
        btn_create: 'Create Service',
        btn_search: 'Search',
        btn_clear: 'Clear',
        search_placeholder: 'Search by title...',
        msg_success_create: 'Service created successfully!',
        msg_success_update: 'Service updated successfully!',
        msg_success_delete: 'Service removed',
        msg_success_delete_text: 'Service removed successfully!',
        msg_error_create: 'Error creating service',
        msg_error_update: 'Error updating service',
        msg_error_delete: 'Error removing service',
        msg_error_delete_text: 'Failed to remove service!',
        msg_error_load: 'Error loading service',
        msg_error_load_text: 'Failed to load service data!',
        msg_error_required_title: 'Title is required!',
        msg_error_title_length: 'Title must be at most 255 characters!',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: 'Service Reservations',
          details_title: 'Reservation Details',
          cancel_title: 'Cancel Reservation',
          cancel_reason_label: 'Cancellation Reason *',
          cancel_reason_placeholder: 'Select cancellation reason',
          cancel_reason_select: 'Select a reason',
          type_tour: 'Tour',
          type_experience: 'Experience',
          type_activity: 'Activity',
          type_room_service: 'Room Service',
          status_pending: 'Pending',
          status_confirmed: 'Confirmed',
          status_cancelled: 'Cancelled',
          status_completed: 'Completed',
          error_title: 'Error',
          error_load: 'Error loading reservations!',
          error_details: 'Error loading reservation details!',
          error_cancel: 'Error canceling the reservation!',
          success_title: 'Success',
          success_cancel: 'Reservation cancelled successfully!',
          warning_title: 'Attention',
          warning_cancel_reason: 'Please select a reason for cancellation.',
          no_details: 'Specific details not available for this reservation type.',
          reasons_tour: [
            'Change of plans',
            'Weather problems',
            'Schedule conflict',
            'Health reasons',
            'Hotel cancellation',
          ],
          reasons_experience: [
            'Change of stay date',
            'Special occasion cancelled',
            'Agenda conflict',
            'Personal reasons',
            'Preference for another service',
          ],
          reasons_activity: [
            'I do not feel prepared',
            'Schedule conflict',
            'Health problems',
            'Change of plans',
            'Activity does not meet expectation',
          ],
          reasons_room_service: [
            'Change of plans',
            'Service not needed',
            'Schedule conflict',
            'Personal reasons',
            'Preference for another service',
          ],
        },
        create_title: 'Create Hotel Activity',
        create_subtitle: 'Add new activity to the hotel',
        edit_title: 'Edit Hotel Activity',
        edit_subtitle: 'Update activity information',
        list_title: 'Hotel Activities',
        list_subtitle: 'Activity and entertainment management',
        field_title: 'Activity Title *',
        field_title_placeholder: "Ex: Yoga Class, Musical Show, Children's Recreation",
        field_title_hint: 'Maximum 255 characters',
        field_time: 'Time *',
        field_time_placeholder: 'Ex: 08:00 - 09:00, Daily at 3pm',
        field_time_hint: 'Maximum 100 characters',
        field_description: 'Description *',
        field_description_placeholder:
          'Describe the activity in detail, its benefits, and what guests can expect...',
        field_image: 'Activity Image',
        field_location: 'Location *',
        field_location_placeholder: 'Ex: Main Pool, Event Hall, Beach',
        field_location_hint: 'Maximum 255 characters',
        field_capacity: 'Capacity *',
        field_capacity_placeholder: 'Ex: 20, if 0 is unlimited',
        field_capacity_hint: 'Maximum 50 characters',
        field_period: 'Period *',
        field_period_placeholder: 'Ex: 00:15 or 01:00 or 00:30',
        field_category: 'Category *',
        field_age_group: 'Age Group',
        field_price: 'Price (R$)',
        field_price_placeholder: '0.00 (leave empty if free)',
        field_price_hint: 'Leave empty for free activity',
        field_requires_reservation: 'Requires Reservation',
        field_requires_reservation_hint: 'Check if the activity requires prior reservation',
        field_is_active: 'Active Activity',
        field_is_active_hint: 'Uncheck to temporarily disable the activity',
        btn_edit: 'Edit Activity',
        btn_delete: 'Delete Activity',
        btn_create: 'Create Activity',
        btn_cancel: 'Cancel',
        msg_success_create: 'Activity created successfully!',
        msg_success_update: 'Activity updated successfully!',
        msg_success_delete: 'Activity deleted successfully!',
        msg_error_create: 'Error creating activity!',
        msg_error_update: 'Error updating activity!',
        msg_error_delete: 'Error deleting activity!',
        msg_error_load: 'Error loading activity!',
        msg_error_required_title: 'Title is mandatory!',
        msg_error_title_length: 'Title must have a maximum of 255 characters!',
        msg_error_required_description: 'Description is mandatory!',
        msg_error_required_time: 'Time is mandatory!',
        msg_error_time_length: 'Time must have a maximum of 100 characters!',
        msg_error_required_location: 'Location is mandatory!',
        msg_error_location_length: 'Location must have a maximum of 255 characters!',
        msg_error_required_capacity: 'Capacity is mandatory!',
        msg_error_capacity_length: 'Capacity must have a maximum of 50 characters!',
        msg_error_price_negative: 'Price must be greater than or equal to zero!',
        remove_schedule: 'Delete Schedule',
        confirm_remove_schedule: 'Are you sure you want to delete this schedule?',
        schedule_seasonal_start: 'Season Start',
        schedule_seasonal_end: 'Season End',
        schedule_start_time: 'Start Time',
        schedule_end_time: 'End Time',
        add_schedule: 'Add Schedule',
        schedule_time: 'Time *',
        schedule_time_placeholder: 'Ex: 08:00 - 09:00, Daily at 3pm',
        schedule_description: 'Description *',
        schedule_days_of_week: 'Days of the Week',
        schedule_status: 'Active Schedule',
        schedule_seasonal_hint: 'Define a seasonal period if applicable',
        field_duration_hint: 'Duration in hours and minutes (ex: 2h30min)',
        field_duration_placeholder: 'Duration in hours and minutes (ex: 2h30min)',
        field_order: 'Order',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        msg_error_order_negative: 'The order must be greater than or equal to zero!',
      },
      hotel_tour: {
        create_title: 'Create Hotel Tour',
        create_subtitle: 'Add new tour to the hotel',
        edit_title: 'Edit Hotel Tour',
        edit_subtitle: 'Update tour information',
        list_title: 'Hotel Tours',
        list_subtitle: 'Manage tours and excursions',
        field_title: 'Tour Title *',
        field_difficulty: 'Difficulty',
        field_duration: 'Duration',
        field_rating: 'Rating',
        field_participants: 'Participants',
        field_schedules: 'Schedules',
        field_includes: 'Includes',
        field_transfer: 'Transfer',
        field_currency: 'Currency',
        field_currency_hint: 'Currency code (ex: BRL, USD)',
        currency_brl: 'Real (BRL)',
        currency_usd: 'Dollar (USD)',
        currency_eur: 'Euro (EUR)',
        field_rating_placeholder: '0.0',
        field_rating_hint: 'Rating from 0 to 5 stars',
        field_participants_min: 'Minimum Participants *',
        field_participants_min_hint: 'Minimum number of participants',
        field_participants_max: 'Maximum Participants',
        field_participants_max_placeholder: 'Leave empty if unlimited',
        field_participants_max_hint: 'Maximum number of participants (optional)',
        field_age_restriction: 'Age Restriction',
        field_age_restriction_placeholder: 'Ex: Over 12 years old, Not recommended for under 18s',
        field_age_restriction_hint: 'Age restrictions (optional)',
        field_physical_requirements: 'Physical Requirements',
        field_physical_requirements_placeholder:
          'Ex: Good physical condition, Ability to walk long distances',
        field_physical_requirements_hint: 'Necessary physical requirements (optional)',
        field_cancellation_hours: 'Cancellation (hours) *',
        field_cancellation_hours_hint: 'Hours before for cancellation',
        field_discount_children: 'Children Discount (%)',
        field_discount_children_hint: 'Discount in percentage',
        field_weather_dependent: 'Weather Dependent',
        field_weather_dependent_hint: 'Check if it depends on weather conditions',
        field_is_active: 'Active Tour',
        field_is_active_hint: 'Uncheck to temporarily disable',
        tab_basic: 'Basic Information',
        tab_details: 'Details and Configurations',
        tab_schedules: 'Schedules',
        tab_includes: 'Included Items',
        tab_image: 'Image',
        no_schedule_added: 'No schedule added',
        click_add_schedule: 'Click on "Add Schedule" to start.',
        includes_title: 'Items Included in the Tour',
        selected: 'Selected',
        field_image_hint: 'Select an image representative of the tour',
        update_info: 'Update tour information',
        field_title_placeholder: 'Ex: City Tour, Beach Excursion, Historical Walk',
        field_title_hint: 'Maximum 255 characters',
        field_time: 'Time *',
        field_time_placeholder: 'Ex: 08:00 - 09:00, Daily at 3pm',
        field_time_hint: 'Maximum 100 characters',
        field_description: 'Description *',
        field_description_placeholder:
          'Describe the tour, highlights, and what guests can expect...',
        field_image: 'Tour Image',
        field_location: 'Location *',
        field_location_placeholder: 'Ex: Center, Beach, Museum',
        field_location_hint: 'Maximum 255 characters',
        field_capacity: 'Capacity *',
        field_capacity_placeholder: 'Ex: 20 people, Unlimited, 10-15 participants',
        field_capacity_hint: 'Maximum 50 characters',
        field_category: 'Category *',
        field_price: 'Price (R$)',
        field_price_placeholder: '0.00 (leave empty if free)',
        field_price_hint: 'Leave empty for free tour',
        field_requires_reservation: 'Requires Reservation',
        field_requires_reservation_hint: 'Check if the tour requires prior reservation',
        btn_edit: 'Edit Tour',
        btn_delete: 'Delete Tour',
        btn_create: 'Create Tour',
        btn_cancel: 'Cancel',
        table_title: 'Title',
        table_time: 'Time',
        table_location: 'Location',
        table_category: 'Category',
        table_price: 'Price',
        table_capacity: 'Capacity',
        table_actions: 'Actions',
        msg_success_create: 'Tour created successfully!',
        msg_success_update: 'Tour updated successfully!',
        msg_success_delete: 'Tour deleted successfully!',
        msg_error_create: 'Error creating tour!',
        msg_error_update: 'Error updating tour!',
        msg_error_delete: 'Error deleting tour!',
        msg_error_load: 'Error loading tour!',
        msg_error_required_title: 'Title is mandatory!',
        msg_error_title_length: 'Title must have a maximum of 255 characters!',
        msg_error_required_description: 'Description is mandatory!',
        msg_error_required_time: 'Time is mandatory!',
        msg_error_time_length: 'Time must have a maximum of 100 characters!',
        msg_error_required_location: 'Location is mandatory!',
        msg_error_location_length: 'Location must have a maximum of 255 characters!',
        msg_error_required_capacity: 'Capacity is mandatory!',
        msg_error_capacity_length: 'Capacity must have a maximum of 50 characters!',
        msg_error_price_negative: 'Price must be greater than or equal to zero!',
        schedule_start_time: 'Start Time',
        schedule_end_time: 'End Time',
        add_schedule: 'Add Schedule',
        schedule_time: 'Time *',
        schedule_time_placeholder: 'Ex: 08:00 - 09:00, Daily at 3pm',
        schedule_description: 'Description *',
        schedule_days_of_week: 'Days of the Week',
        schedule_status: 'Active Schedule',
        schedule_seasonal_hint: 'Define a seasonal period if applicable',
        field_duration_hint: 'Duration in hours and minutes (ex: 2h30min)',
        field_duration_placeholder: 'Duration in hours and minutes (ex: 2h30min)',
        schedule_seasonal_start: 'Season Start',
        schedule_seasonal_end: 'Season End',
        difficult: {
          easy: 'Easy',
          medium: 'Moderate',
          hard: 'Hard',
          extreme: 'Extreme',
        },
        field_order: 'Order',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        header_order: 'Order',
        msg_error_order_negative: 'The order must be greater than or equal to zero!',
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
      },
      permissions: {
        color_variations: 'Color Variations',
        food: 'Smart Order',
        content: 'Webapp Interface',
        buttons: 'Buttons',
        sessions: 'Sessions',
        smartorder: 'Product Management',
        category: 'Categories',
        subcategory: 'Subcategories',
        product: 'Products',
        mark: 'Brands',
        grid: 'Grids',
        variation: 'Variations',
        catalog: 'Catalogs',
        integration: 'Integrations',
        int_pos: 'POS',
        int_gateway: 'Payment Method',
        messaging: 'Messaging',
        sms: 'Status and SMS',
        multichannel: 'Multichannel',
        report: 'Reports',
        saleorder: 'Orders',
        indicators: 'Indicators',
        orderReport: 'Orders',
        imports: 'Image Import',
        importProductImage: 'Products',
        importProductImageSKU: 'Variations',
        importCategoryImage: 'Categories',
        customers: 'Customers',
        customer_report: 'Customer List',
        measurement_unit: 'Measurement Units',
        logs: 'Logs',
        settings: 'Settings',
        charge_integration: 'Charges',
        summaryAccess: 'Accesses',
        sellerAccess: 'Seller Dash',
        managerAccess: 'Manager Dash',
        managerGroupAccess: 'Group Manager Dash',
        orders: 'Orders',
        support: 'Support',
        translate: 'Languages and Relationships',
        application: 'Webapp',
        messenger: 'Messaging',
        others: 'Others',
        settings_store: 'Store Settings',
        settings_hotel: 'Settings',
        modalities: 'Modalities',
        delivery_tax: 'Delivery Fee',
        shifts: 'Shifts',
        whatsappweb: 'WhatsApp Web',
        filemanager: 'File Manager',
        payment_plans: 'Payment Plans',
        settings_account: 'Account Settings',
        account: 'Account',
        groups: 'Groups',
        users: 'Users',
        terms: 'Terms',
        highlights: 'Highlights',
        menu: 'Menu',
        productReport: 'Products',
        optional: 'Add-ons List',
        locations: 'Sectors',
        stores_location: 'Establishments',
        service: 'Services',
        service_items: 'Services',
        service_category: 'Categories',
        feed: 'Feed',
        structured_content: 'Essential Services',
        orders_room_service: 'Room Orders',
        orders_activities: 'Activity Orders',
        queue: 'Waiting Queue',
        queue_config: 'Configurations',
        queue_manager: 'Management',
        checkout: 'Customer Data',
        booking: 'Reservation',
        booking_management: 'Management',
        booking_config: 'Configurations',
        booking_environment: 'Environments',
        booking_day: 'Day Reservations',
        booking_report: 'Reports',
        booking_managerday: 'Daily Management',
        booking_management_dashboard: 'Reservation Dashboard',
        table_management: 'Table Management',
        table_allocation_report: 'Table Allocation Report',
        table_management_dashboard: 'Table Management Dashboard',
        liveShop: 'Live Commerce',
        icon_library: 'Icon Library',
        stores: 'Stores/Customers',
        segments: 'Segments',
        payment: 'Payments',
        serviceCategory: 'Service Category',
        SDS: 'KDS',
        sds_manage: 'My KDS',
        sds_layout: 'Personalization',
        sds_link: 'Configurations',
        sds_display: 'Displays',
        /* Aggregator */
        config: 'Configurations',
        config_account: 'Account Data',
        config_sector: 'Area of activity',
        config_user: 'Users',
        config_term: 'Terms',
        subCategory: 'Subcategory',
        footer: 'Footer Resources',
        footerFeature: 'Enable resources',
        footerContent: 'Resource Feed',
        footerContentAddEdit: 'Resources',
        webapp: 'Personalize',
        webapp_qrcode: 'Generate QR Code',
        ia_menu: 'Artificial Intelligence',
        ia_config: 'Configurations',
        ia_fit: 'Training',
        ia_file_manager: 'File Manager',
        ia_folders: 'Folders',
        ia_files: 'Files',
        ia_settings: 'Settings',
        ia_folders_blank: 'No folder found',
        ia_filter: 'Filter',
        ia_recharge: 'Recharge',
        ia_final_date: 'End Date',
        ia_initial_date: 'Start Date',
        summarize: 'Dashboard',
        consumption: 'AI Consumption',
        ct_account: 'Consumption and Value',
        ct_s3_account: 'S3 Account',
        ct_data_cost_account: 'Data and Costs',
        publication_highlight_banner: 'Featured Banner',
        publication: 'Advertising',
        cost: 'Costs',
        security_settings: 'Security Settings',
        coupon: 'Coupon',
        clean_safe: 'Clean & Safe',
        service_requests: 'Service Forms',
        grid_hotel: 'Service Grid',
        /*Hospitality */
        hotel_maintenance: 'Maintenance',
        hotel_room: 'Room',
        hotel_reservation: 'Room Reservations',
        hotel_activities_experiences: 'Activities and Experiences',
        hotel_activities: 'Activities',
        hotel_tour: 'Hotel Tour',
        hotel_tour_schedules: 'Hotel Tour Schedules',
        hotel_tour_reservation: 'General Reservations',
        hotel_experiences: 'Experiences',
        hotel_info: 'Information',
        hotel_reservations: 'Reservations',
        hotel_schedules: 'Hotel Schedule',
        publication_banner: 'Banner',
        feed_back: 'Feed Back',
        feedback_satisfaction: 'Feedback and Satisfaction',
        grid_hotel_feedback: 'Grids',
        feedback_list: 'Form',
        feedback: 'Responses',
      },
      feedback_reviews: {
        title: 'Search and Satisfaction Reviews',
        subtitle: 'View and manage all ratings and responses from feedback forms',
        breadcrumb_feedback: 'Satisfaction Feedback',
        error: 'Error',
        success: 'Success',
        loading: 'Loading...',
        loading_details: 'Loading review details...',
        close: 'Close',
        error_loading_reviews: 'Error loading reviews',
        error_loading_details: 'Error loading review details',
        error_changing_status: 'Error changing review status',
        success_status_changed: 'Status changed successfully',
        confirm_status_change: 'Confirm status change',
        confirm_status_change_text: 'Are you sure you want to change the status of this review?',

        // Status
        status_pending: 'Pending',
        status_approved: 'Approved',
        status_rejected: 'Rejected',

        // Field types shown in responses
        types: {
          title: 'Title',
          text: 'Text',
          textarea: 'Text Area',
          stars: 'Rating',
          checkbox: 'Checkbox',
          radio: 'Single Choice',
          select: 'Select',
          number: 'Number',
          date: 'Date',
          time: 'Time',
          image: 'Image',
          link: 'Link',
        },

        anonymous_active: 'Active',
        anonymous_inactive: 'Inactive',

        // Filters
        filters: {
          feedback_form: 'Form',
          status: 'Status',
          anonymous: 'Anonymous',
          select_anonymous_placeholder: 'All',
          rating: 'Rating',
          reservation_id: 'Reservation ID',
          start_date: 'Start Date',
          end_date: 'End Date',
          date: 'Date',
          all_forms: 'All Forms',
          all_status: 'All Statuses',
          all_ratings: 'All Ratings',
          select_form_placeholder: 'Select a form',
          select_status_placeholder: 'Select a status',
          select_rating_placeholder: 'Select a rating',
          reservation_id_placeholder: 'Enter reservation ID',
          start_date_placeholder: 'Select start date',
          end_date_placeholder: 'Select end date',
          filter_button: 'Filter',
          clear_filters: 'Clear Filters',
        },

        // Table
        table: {
          feedback_form: 'Form',
          customer: 'Customer',
          room: 'Room',
          reservation: 'Reservation',
          rating: 'Rating',
          status: 'Status',
          date: 'Date',
          time: 'Time',
          actions: 'Actions',
        },

        // Actions
        actions: {
          view_details: 'View Details',
          approve: 'Approve',
          reject: 'Reject',
        },

        // Review Details
        review_details: 'Review Details',
        room: 'Room',
        reservation: 'Reservation',
        feedback_form: 'Form',
        responses: 'Responses',
        technical_info: 'Technical Information',
        created_at: 'Created at',
        updated_at: 'Updated at',
        review_id: 'Review ID',
        plugin_space_id: 'Plugin Space ID',
        anonymous_response: 'Anonymous Response',
        no_reservation_linked: 'This response is not linked to a specific reservation',
        no_detailed_responses: 'No detailed responses available for this review',
        anonymous_label: 'Anonymous',
        email_anonymous: 'Email not available (anonymous response)',
        email_not_informed: 'Email not provided',
        response_title: 'Title',
        no_rating_provided: 'No rating provided',
        no_items_selected: 'No items selected',
        no_option_selected: 'No option selected',
        no_answer_provided: 'No answer provided',
        form_label: 'Form:',
        client_not_identified: 'Customer not identified',
        post: 'Posts',
        post_category: 'Post Categories',
        post_content: 'Post Content',
        booking_hotel: 'Reservation Management',
        grid_hotel_booking: 'Service Grids',
        booking_config_hotel: 'Service Reservations',
        page_publications: 'Page Publications',
        communication: 'Communication',
        communicationCenter: 'Communication Center',
        hotel_management: 'Hotel Management',
        hotel_management_entertainment: 'Entertainment',
        product_color_variations: 'Color Variations',
      },
      // Translations for Color Variations Workbench
      workbench: {
        page_title: 'Color Variations',
        page_subtitle: 'Manage product color variations',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_workbench: 'Color Workbench',
        
        // Mode Selection
        selectMode: 'Select Mode',
        chooseProdutOrVariation: 'Choose to work with a Product or Variation',
        product: 'Product',
        productDescription: 'Choose from the registered products in your store',
        variation: 'Variation',
        variationDescription: 'Choose from registered variations',
        
        // Product/Variation Selection
        selectProduct: 'Select a Product',
        selectVariation: 'Select a Variation',
        searchProduct: 'Search product by name or code...',
        searchVariation: 'Search variation by SKU or product name...',
        noProductsFound: 'No products found',
        noProductsMatchSearch: 'No products found matching search criteria',
        noVariationsFound: 'No variations found',
        noVariationsMatchSearch: 'No variations found matching search criteria',
        noImagesFound: 'No images found for this product/variation',
        description: 'Select a product or variation to start creating custom color variations.',
        showingResults: 'Showing',
        of: 'of',
        backButton: 'Back',
        
        // Image and Color Selection
        selectImage: 'Select Image',
        selectColor: 'Select Color',
        colorDescription: 'Description (Optional)',
        descriptionPlaceholder: 'Describe the change you want to make...',
        selectImageFirst: 'Please select an image first',
        processingError: 'Error processing variation',
        
        // Buttons
        generateVariation: 'Generate Variation',
        processing: 'Processing...',
        processingTimeSeconds: '{time}s',
        
        // Preview
        selectedImagePreview: 'Selected Image Preview',
        resultPreview: 'Result Preview',
        originalImage: 'Original Image',
        processedImage: 'Processed Image',
        targetColor: 'Target Color',
        processingTime: 'Processing Time',
        
        // Actions
        approveAndApply: 'Approve and Apply',
        reject: 'Reject',
        applyVariation: 'Apply Variation',
        applyTarget: 'Where do you want to apply this variation?',
        
        // Apply Dialog
        createNewVariation: 'Create New Variation',
        newVariationInfo: 'A new variation will be created with this image',
        replaceExistingVariation: 'Replace Existing Variation',
        selectVariationToReplace: 'Select the variation you want to replace',
        replaceProductImage: 'Replace Product Image',
        selectProductToReplaceImage: 'Select which product image will be replaced',
        
        // Messages
        variationSavedSuccess: 'Variation saved successfully!',
        errorSavingVariation: 'Error saving variation',
        successTitle: 'Success',
        errorTitle: 'Error',
        warningTitle: 'Warning',
        
        // Dialog Buttons
        cancel: 'Cancel',
        save: 'Save',
        confirm: 'Confirm',
        close: 'Close',
      },
      customer: {
        select_group: 'Select a group',
        select: 'Select',
        create: 'Create customer',
        create_group: 'Create group',
        edit: 'View customer',
        search_custom: 'Search...',
        customer: 'Customers',
      },

      buttons: {
        create: 'Create',
        back: 'Back',
        previous: 'Previous',
        register_pluginspace: 'Register Pluginspace',
        access: 'Access',
        add_modality: 'Add modality',
        add_km: 'Add Km',
        zip_code_list: 'Zip Code List',
        add_zip_code: 'Add Zip Code',
        area: 'Shipping Areas',
        list_of_negative_renge_zip_code: 'Negative Zip Code List',
        add_negative_zip_code: 'Add Negative Zip Code',
        add_user: 'Add user',
        generate_password: 'Generate password',
        generate_sku: 'Generate SKU',
        add_group: 'Add group',
        save: 'Save',
        add_term: 'Add term',
        add_integration: 'Add integration',
        filter: 'Filter',
        search: 'Search',
        register_product: 'Register Product',
        choose_files: 'Choose files',
        add_categories: 'Add categories',
        add_subcategories: 'Add subcategories',
        add_brand: 'Add brand',
        close: 'Close',
        add_grade: 'Add grid',
        add: 'Add',
        add_variation: 'Add variation',
        confirm_grades: 'Confirm grids',
        add_catalog: 'Add catalog',
        generete_qr_code: 'Generate QR Code',
        personalize: 'Personalize',
        settings: 'Settings',
        add_interval: 'Add interval',
        add_gateway: 'Add gateway',
        overview: 'Overview',
        view: 'View',
        load_csv: 'Load file',
        download_csv: 'Download Standard XLSX',
        att_page: 'Refresh page',
        export: 'Export',
        add_service: 'Register Service',
        add_environment: 'Add environment',
        generate_ia: 'Propose',
        clear_table_card: 'Clear table or command',
        propose_image: 'Propose image',
        cancel: 'Cancel',
        next: 'Next',
      },

      global: {
        success: 'Success',
        error: 'Error',
        warning: 'Attention',
        active: 'Active',
        inactive: 'Inactive',
      },

      modals: {
        warning_confirm: 'Are you sure?',
        warning_save: 'Save',
        warning_close: 'Close',
        text_close: 'Close',
      },

      general: {
        delete_item: 'Do you want to delete this item?',
        delete_product_observation:
          'The variations of this product will also be excluded, do you want to continue anyway?',
        delete_classification_observation:
          'By excluding this category, all related products will go to General, do you want to continue?',
        delete: 'Delete',
        edit: 'Edit',
        duplicate: 'Duplicate',
        attention: 'Attention',
        actions: 'Actions',
        select: 'Select',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Here are the items listed along with their respective actions',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Fill in the information below and click the create button to save the changes',
        save_changes_edit:
          'Fill in the information below and click the save button to confirm the changes',
        save_changes_duplicate:
          'Validate or change the information below and click the save button to confirm the changes',
        active: 'Active',
        inactive: 'Inactive',
        showing: 'Showing',
        of: 'of',
        to: 'to',
        records: 'records',
        today: 'Today',
        copy: 'Copy',
        linkS3: 'Link',
        linkedS3: 'Linked',
        downloadS3: 'Download',
        downloadedS3: 'Download Started',
        copied: 'Copied',
        copy_link: 'Copy seller link',
        test: 'Test',
        success: 'Success',
        error: 'Error',
      },

      pluginspaces: {
        hospitality: 'Hotels',
        food: 'Food',
        healthcare: 'Hospitality',
        varejo: 'Retail',
        fashion: 'Fashion',
      },

      dashboard: {
        totals_by_products: 'Totals by product',
        totals_by_category: 'Totals by category',
        last_orders: 'Latest orders',
        products: 'Products',
        quantity: 'Quantity',
        total: 'Total',
        category: 'Category',
        welcome: 'Welcome to Ninegrid',
        describe_dashboard:
          'Here you have all the tools to manage your store simply and efficiently. Explore the side menus to navigate our functionalities. Good job!',
      },

      modalities: {
        modalities: 'Modalities',
        modalitie: 'Modality',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Here are the modalities listed along with their respective actions',
        delivery: 'Delivery',
        withdraw: 'Pickup',
        active: 'Active',
        inactive: 'Inactive',
        name: 'Name',
        code: 'Code',
        actions: 'Actions',
        search: 'Search',
        type: 'Type',
        sector_name: 'Sector name',
        table: 'Table',
        room: 'Room',
        counter: 'Counter',
        internal: 'Internal Delivery',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: 'Delivery Fee',
        create_delivery_fee: 'Create delivery fee',
        edit_delivery_fee: 'Edit delivery fee',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Fill in the information below and click the create button to save the changes',
        save_changes_edit:
          'Fill in the information below and click the save button to confirm the changes',
        km_min: 'Minimum Km',
        km_max: 'Maximum Km',
        value: 'Value',
        actions: 'Actions',
        patterns: 'Import Patterns',
        import_file:
          'To import the files the first cell of the file must follow one of the following patterns:',
        import_delivery: 'To import by range: kmmin, kmmax, Value',
        import_cep: 'To import Zip Code: cep_start, cep_end, value',
        import_cep_negative: 'To import Negative Zip Code: cep_start, cep_end',
        model: 'Model',
        continue_import: 'All your records will be replaced, are you sure you want to continue?',
        cep_delivery: 'Delivery Zip Codes',
        cep_info: 'Here are the Delivery Zip Codes listed along with their respective actions.',
        cep_start: 'Zip Code Start',
        cep_end: 'Zip Code End',
        create_cep: 'Create Delivery Zip Codes',
        edit_cep: 'Edit Delivery Zip Codes',
        cep_delivery_negative: 'Negative Delivery Zip Codes',
        cep_info_negative:
          'Here are the Negative Delivery Zip Codes listed along with their respective actions.',
        create_cep_negative: 'Create Negative Zip Code',
        edit_cep_negative: 'Edit Negative Zip Code',
        delete_cep_negative: 'Delete Negative Zip Code',
      },

      user: {
        user: 'Users',
        here_are_listed_the_users_along_with_their_respective_actions:
          'Here are the users listed along with their respective actions',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Fill in the information below and click the create button to save the changes',
        save_changes_edit:
          'Fill in the information below and click the save button to confirm the changes',
        picture: 'Photo',
        name: 'Name',
        type: 'Type',
        registration: 'Registration',
        create_user: 'Create user',
        edit_user: 'Edit user',
        profile_picture: 'Profile picture',
        password: 'Password',
        generate_pass: 'Generate Password',
        access_level: 'Access group',
        select_a_access_level: 'Select an access group',
        select_type: 'Select a type',
        active: 'Active',
        actions: 'Actions',
        discount_permission: 'Permission for discount on sale',
        discount_value: 'Maximum discount value (%)',
        phone: 'Phone number',
      },

      groups: {
        groups: 'Groups',
        group: 'Group',
        here_are_listed_the_groups_along_with_their_respective_actions:
          'Here are the groups listed along with their respective actions',
        name: 'Name',
        Integrations: 'Integrations',
        means_of_payment: 'Payment method',
        products: 'Products',
        category: 'Categories',
        subcategory: 'Subcategory',
        indicators: 'Indicators',
        requests: 'Orders',
        reports: 'Reports',
        messenger: 'Messaging',
      },

      shifts: {
        shifts: 'Shifts',
        here_are_listed_the_shifts_for_each_day_of_the_week:
          'Here are the shifts listed for each day of the week',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        start: 'Start',
        end: 'End',
      },

      account: {
        account: 'Account',
        edit_account: 'Edit account',
        registration_number: 'CNPJ',
        corporate_name: 'Corporate name',
        customer_name: 'Name',
        name_of_the_establishment: 'Establishment name',
        subdomain: 'Subdomain',
        code: 'Code',
        default_language: 'Default language',
        default_currency: 'Default currency',
        login_of_person_in_charge: 'Account manager login',
        name_of_person_in_charge: 'Manager name',
        address: 'Address',
        zip_code: 'Zip Code',
        number: 'Number',
        neighbourhood: 'Neighborhood',
        city: 'City',
        state: 'State',
        public_place: 'Street',
        address_complement: 'Complement',
        info: 'To change the subdomain contact support',
      },

      terms: {
        terms: 'Terms',
        here_are_the_terms_of_acceptance_of_the_sales_platform:
          'Here are the terms of acceptance of the sales platform',
        create_your_term: 'Create your term',
        term_name: 'Term name',
        valid_until: 'Valid until',
        name: 'Name',
        expirated: 'Expires',
      },

      payment_plans: {
        payment_plans: 'Payment Plans',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          'Here are the payment plans listed along with their respective actions',
        create_payment_plans: 'Create Payment Plans',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          'Fill in the information below and click the create button to save the changes',
        erp_integration: 'ERP Integration',
        integration_type: 'Integration Type',
        select_an_integration: 'Select an integration',
        card_flag: 'Card Flag',
        flag: 'Flag',
        type: 'Type',
        erp_code: 'ERP Code',
        card_installment: 'Installment',
        payment_plan: 'Payment Plan',
        installment: 'Installment',
        time: 'Term',
        credit: 'Credit',
        debit: 'Debit',
      },

      indicators: {
        indicators: 'Indicators',
        orders: 'Orders',
        filters: 'Filters',
        first: 'Start',
        end: 'End',
        total_order: 'Total orders',
        revenue: 'Revenue',
        orders_by_location: 'Orders by modality',
        orders_by_month: 'Orders by month',
        orders_by_day: 'Orders by day',
        orders_by_hour: 'Orders by hour',
        orders_by_month_sector: 'Orders by month and modality',
        orders_by_day_sector: 'Orders by day and modality',
        orders_by_hour_sector: 'Orders by hour and modality',
        product: 'Products',
        categories: 'Categories',
        sales_by_category: 'Sales by category',
        revenue_by_category: 'Revenue by category',
        average_ticket: 'Average ticket',
        quantity: 'Quantity',
        summary: 'Summary',
        summaryAccess: 'Accesses',
        summaryAccessGroup: 'Areas accessed by period',
        summaryTimeAccessGroup: 'Total by hour',
        summaryIPAccessGroup: 'Total by user',
        summarySellerCart: 'Total carts created by seller',
        period: 'Choose a period',
        summaryTypeCust: 'Sum by cost type',
        summaryComposition: 'Cost composition',
        cost: 'Costs',
        customer: 'Customers',
        seller_sales_by_category: 'Seller sales by category',
        summary_seller: 'Seller Summary',
        sellers_invoice: 'Seller Invoicing',
        comparative_sales_by_channel: 'Sales comparative by channel',
        select_view: 'Select view',
        sales: 'Sales',
        attended_customers: 'Attended customers',
        carts: 'Recorded carts',
        sales_conversion: 'Sales conversion',
        mean_ticket: 'Average ticket',
        sales_client: 'Comparative/ Ranking of sales by customers',
        sellers: 'Sellers',
        summary_store: 'Store Summary',
        accesses: 'Visits',
        active_sellers: 'Active sellers',
        revenue_store: 'Store Invoicing',
        revenue_group: 'Group Invoicing',
        comparative_sales_by_seller: 'Sales comparative by seller',
        comparative_sales_by_store: 'Business unit comparative',
        comparative_by_seller: 'Commercial Force - Sellers Comparative',
        stores: 'Stores',
        invoicing: 'Invoicing',
        active_stores: 'Active stores',
        summary_group: 'Group Summary',
        invoice_by_store: 'Invoicing by store',
        rank_sellers: 'Sellers Ranking',
        rank_stores: 'Stores Ranking',
      },

      customer_list: {
        customer_list: 'Customer List',
        listed_customers: 'Here are the customers listed along with their respective actions.',
        select_time: 'Period of orders placed',
        name: 'Name',
        first: 'Start',
        end: 'End',
        phone: 'Phone',
        date: 'Date',
        detail: 'Customer Details',
        total_profit: 'Total Profit',
        total_itens: 'Total Items',
        total_orders: 'Total Orders',
        order_between: 'Orders between',
        order_detail: 'Order detail',
        create: 'Create Customer',
        go_detail: 'View details',
        product: 'Product',
        value: 'Value',
        quantity: 'Qty.',
        total: 'Total',
        edit: 'Edit Customer',
      },

      smart_order: {
        smart_order: 'Smart Order',
        service_classification: 'Service Classification',
        message_warning_find_variation:
          'When searching by name, pay attention to the reference code and SKU, and the product name',
        product: 'Products',
        referenceCode: 'Reference Code',
        create_product: 'Create Product',
        here_are_listed_the_products_along_with_their_respective_actions:
          'Here are the products listed along with their respective actions',
        name: 'Name',
        code: 'Code',
        color_code: 'Color Code',
        crop_image: 'Crop Image',
        use_original_image: 'Use Original Image',
        select_image_format: 'Select Image Format',
        use_selected_size: 'Use Selected Size',
        format_640x640: '640x640 (Square)',
        format_600x900: '600x900 (Portrait)',
        product_data: 'Product Data',
        mark: 'Brand',
        measurement_unit: 'Measurement Unit',
        description: 'Description',
        technical_specification: 'Technical Specification',
        from: 'of',
        characters: 'characters',
        order: 'Order',
        product_image: 'Product Images',
        additional_images: 'Additional Images',
        product_groups: 'Customer Groups for the Product',
        categories: 'Categories',
        here_are_listed_the_categories_along_with_their_respective_actions:
          'Here are the categories listed along with their respective actions',
        image: 'Product image',
        image_variation: 'Variation image',
        category: 'Category',
        category_parent: 'Parent Category',
        category_name: 'Category name',
        category_code: 'Category code',
        perfil_image: 'Profile image',

        subcategories: 'Subcategories',
        subcategory: 'Subcategory',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          'Here are the subcategories listed along with their respective actions',
        select_category: 'Select a category',

        marks: 'Brands',
        listened_marks: 'Here are the brands listed along with their respective actions',

        measurements_units: 'Measurement Units',
        listened_measurement:
          'Here are the measurement units listed along with their respective actions',

        grid_products: 'Grids',
        listened_grid: 'Here are the product grids listed along with their respective actions',
        grid_name: 'Grid name',
        grid_code: 'Code',
        variation: 'Variation',
        grid: 'Grid',
        grids: 'Grids',

        variations: 'Variations',
        listened_variations:
          'Here are the product variations listed along with their respective actions',
        modality: 'Modality',
        select_modality: 'Select a modality',
        prod: 'Product',
        select_product: 'Select a product',
        no_variation: 'Product without variation',
        variation_product: 'Product variation',
        cost_price: 'Cost Price',
        sell_price: 'Sale Price',
        promotional_price: 'Promotional Price',
        weight: 'Weight',
        height: 'Height',
        width: 'Width',
        depth: 'Depth',
        availability: 'What is the product availability?',
        when_product_stock: 'When the product runs out of stock?',
        stock: 'Quantity of products in stock',
        min_stock: 'Minimum stock',
        price: 'Price',

        catalogs: 'Catalogs',
        catalog: 'Catalog',
        create_catalog: 'Create Catalog',
        edit_catalog: 'Edit Catalog',
        catalog_link: 'Copy Catalog Link',
        listened_catalogs:
          'Here are the product catalogs listed along with their respective actions.',
        validity: 'Validity',
        first: 'Start',
        end: 'End',
        search_products: 'Product Search',

        product_status: 'Product status',
        sku: 'SKU/EAN',
        status_variation: 'Variation status',
        specification: 'Specification',
        price_promotional: 'Price with discount',
        inventory: 'Inventory',
        preparation_time: 'Preparation time',
        service_title: 'Here are the services listed along with their respective actions.',

        initial_hour: 'Initial time',
        final_hour: 'Final time',

        date_start: 'Start Date',
        date_end: 'End Date',

        add_group: 'Add-ons List',
        no_add: 'This product is not yet associated with any add-ons list.',
        already_add: 'This product is associated with the following add-ons lists.',
        associate_add: 'Associate with an add-ons list',
        associate: 'Associate',
        choose_add: 'Choose the add-ons lists that will be associated with this product.',
        no_group_add: 'No add-ons lists available to associate.',
        remove_add: 'Remove association',
        remove_add_text:
          'Do you want to remove the association of this product with the add-ons list "@"?',
        limit_range: 'Maximum range limit reached',

        remove_add_soon:
          'Attention! This tab will be removed soon. You can continue managing your add-ons normally. Access the "Basic Information" tab and go to the "Add-on Group" section to see this product\'s add-ons.',
        create_image_ia: 'AI Image Proposal',
        create_image_ia_text: 'Provide a product description to generate the images.',
        generate_images: 'Generate images',
        generate_description: 'Customize description',
        generate_new_options: 'Generate new options',
        save_image_selected: 'Save the selected photo',
        reference_image_ia: 'Reference image',
        image_qtd_ia: 'Image quantity',
        save_img_ia: 'Save images',
        cancel: 'Cancel',

        more_category: 'See more configurations of this category',
        selectAll: 'Select All',
        alterLot: 'Change Batch',
        edit_category:
          'It is not allowed to change the category link, we instruct you to create a new category',

        catalog_image: 'Catalog Image',
      },

      service_grid: {
        service_grid: 'Service Grids',
        service_grid_single: 'Service Grid',
        create_service_grid: 'Create Service Grid',
        edit_service_grid: 'Edit Service Grid',
        service_grid_name: 'Service Grid Name',
        service_grid_name_placeholder: 'Service grid name',
        start_hour: 'Start Time',
        start_hour_placeholder: '00:00',
        end_hour: 'End Time',
        end_hour_placeholder: '23:59',
        interval: 'Interval',
        interval_placeholder: '00:15',
        interval_tooltip: 'Time interval between orders',
        service_list: 'Service List',
        service_placeholder: 'Services',
        missing_fields: 'Missing fields',
        missing_fields_message: 'Check if you filled in all fields!',
        grid_created: 'Grid registered',
        grid_created_message: 'Registration performed successfully!',
        grid_updated: 'Grid changed',
        grid_updated_message: 'Edition performed successfully!',
        error: 'Error',
        error_create_message: 'Error registering the grid!',
        error_update_message: 'Error changing the grid!',
        fill_information_create:
          'Fill in the information below and click the create button to save the changes',
        save_changes_edit:
          'Fill in the information below and click the save button to confirm the changes',
        dashboard: 'Dashboard',
        title: 'Title',
        listed_grids: 'Here are the service grids listed along with their respective actions',
        grid_deleted: 'Grid deleted',
        grid_deleted_message: 'Deletion performed successfully!',
        error_delete_message: 'Error deleting the grid!',
        status: 'Status',
        grid_linked_warning: 'Grid linked',
        grid_linked_message:
          'This grid is linked to {count} service form(s) and cannot be excluded.',
      },

      webapp: {
        webapp: 'Webapp',
        generate_qrcode: 'Generate QR Code',
        personalize: 'Personalize',
        settings: 'Settings',
        link: 'Link to Webapp',

        webapp_data: 'Webapp Data',
        name: 'Name',
        place: 'Place',
        product_pagination: 'Quantity of products in pagination',
        logo_ninegrid: 'Ninegrid Logo',
        light: 'Light',
        dark: 'Dark',
        logo_totvs: 'TOTVS Logo',
        use_icon_menu: 'Use icon in Webapp menu',
        description: 'Description',
        icon: 'Icon',
        color_setting: 'Color configuration',
        background_webapp: 'Webapp Background',
        background_default_webapp: 'Default WebApp Color',
        background_header: 'Header background',
        text_header: 'Header text',
        icon_header: 'Header icons',
        background_footer: 'Footer background',
        icon_footer: 'Footer icons',
        highlight_footer: 'Footer highlight',
        notification_cart: 'Cart notification',
        notification_text: 'Notification text',
        home_button: 'Home button',
        text_home_button: 'Home button text',
        title_bar: 'Title bar',
        text_title_bar: 'Title bar text',
        icon_title_bar: 'Title bar icons',
        text_category: 'Categories text',
        webapp_button: 'Webapp Theme',
        text_button: 'Buttons text',
        background_menu: 'Side menu background',
        text_menu: 'Side menu text',
        price_card_background: 'Price card background',
        price_card_font_color: 'Price card font color',
        order_status: 'Order status',
        order_active_status: 'Active order status',
        text_order_active_status: 'Order status text',
        info_cart: 'Cart information',

        settings_webapp: 'Webapp Settings',
        type_delivery: 'Delivery restriction type',
        integration: 'Integration',
        select_integration: 'Select an integration',
        payment_method_card: 'Payment method Card',
        payment_method_pix: 'Payment method Pix',
        payment_method_delivery: 'Payment method on delivery',
        consent_letter: 'Activate consent letter',
        product_no_stock: 'Sale of products without stock',
        show_subcategory: 'Display subcategory',
        show_observation: 'Display observation',
        use_category_list: 'Display subcategories and products in lists',
        use_category_list_v2: 'Display categories and subcategories in lists',
        use_product_list: 'Display products in lists',
        remove_shadow: 'Do not add shadow to categories and catalogs',
        remove_show_mode: 'Remove display mode',
        no_shadow: 'Do not add shadow to categories',
        is_order_number: 'Order category',
        order_number: 'By order',
        order_category: 'Alphabetical',
        show_layout: 'Display Layout',
        image_type: 'Product image style',

        withdraw_fee: 'Pickup Fee',
        minimum_value: 'Minimum Order Value',
        seller_checkout: 'Checkout Modality',

        no_sales: 'Do not allow sales',
        safe_mode: 'Safe Mode',
        time_safe_mode: 'Safe Mode Session Time (in minutes)',
        limit_characteres_explanation:
          'For stores with Wintor or Protheus integration, the recommended maximum is 50 characters.',
        limit_characteres: 'Character limit',

        skip_entry: 'Skip entry screen',
        payment_table: 'Payment at the table',

        payment_card: 'Payment on command',

        slides_homePage: 'Homepage Highlight Images',
        slides_initial: 'Initial Highlight Images',

        slides_not_found: 'No slider image found',

        externalLink: 'External Link',
        buttonType: 'Button Type',
        ableUserLocation: 'Allow address search by location',
        ableWaiter: 'Disable call waiter option',
        closeAccountButton: 'Remove account closing button',
        emitNfChef: 'Issue Invoice after payment of the order? (Counter/Table/Command)',

        seller_cart_limit_time: 'Seller cart expiration time per hour',
        seller_cart_limit_time_explanation: "Maximum time the customer can use the seller's cart",
        settings_webapp_aggregator: 'Personalize',
        generate_qrcode_webapp_aggregator: 'Generate QR code',
        qrcode_webapp_aggregator: 'Web Application',
        security_settings: 'Security Settings',
        maximus_radius: 'Location: Allowed proximity radius (in meters)',
        access_maximus: 'Maximum number of accesses per table',
        limit_time: 'Access time for the command to expire (in minutes)',
        password: 'Password to unlock access',
        flag_discount: 'Discount flag format',
        color_flag_discount: 'Tag color',

        config_tags: 'Configure Tags',
        promotional_tags: 'Promotional tag',

        pre_created: 'Pre-registration',

        show_classification_button: 'Show button to view all categories',
        show_catalog_button: 'Show button to view all catalogs',
        show_catalog_name: 'Show catalog name',
        show_classification_name: 'Show category name',
        show_mark_name: 'Show product brand',
        show_stock_quantity: 'Show product stock',
        show_promotional_tags: 'Show Promotional Label',
        show_product_sku: 'Show product sku',
        tag_display_groups: 'Show tag groups in product listing',
        text_free_delivery: 'Customized text for free delivery or pickup',
        tooltip_free_delivery:
          'If filled, this text will be displayed when delivery or pickup is free. If empty, the value R$ 0.00 will be displayed',
        place_holder_free_delivery: 'Ex: Free',
        no_show_grid: 'Omit grids of unique variations of the product',
        explain_show_grid:
          'Hides grids with unique variations. Grids with multiple options (ex: sizes L; XL) will remain visible in the product selection, but hidden elsewhere.',

        type_image: 'Image Type',
        type_image_square: 'Square',
        type_image_rectangle: 'Rectangular',

        directlink: 'Direct Link',
        infoDirectLink:
          'Not mandatory, only when it is necessary to send directly to another page or website, maximum of 350 characters',

        block_add_in_limit: 'Block addition at the limit',

        family_fonte: 'Font Family',
        rounding_images: 'Image Rounding',
        rounding_bars: 'Bar Rounding',
        color_icons: 'Icons Color',
        color_icons_header_footer: 'Icons Color in Header and Footer',
        background_icon_button: 'Icons background color',
        background_icon_custom: 'Custom Color',
        restaurant_list: 'Restaurant List',
        restaurant_display_mode: 'Change restaurant display mode',
        icon_button_size: 'Button icon size',
        shadow_image: 'Image Shadow',
        black_logo_nine: 'Dark Ninegrid Logo',
        skip_loud_screen: 'Skip Loading Screen',
        can_acesse_restaurant: 'Allow catalog (Store/Restaurant) viewing without login',
        info_acesse_restaurant:
          'Enabling this flag allows users to access the restaurant or store menu/catalog without needing to log in. If an active payment integration exists, login will be requested directly in the store or restaurant WebApp itself, before the payment step, so that the order is correctly associated with the user context (profile/reservation) in the hotel system.',
      },

      integration: {
        integration: 'Integration',
        means_of_payment: 'Payment Method',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          'Here are the payment methods listed along with their respective actions',
        PDV: 'POS Integration',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          'Here are the integrations listed along with their respective actions',
        integration_name: 'Integration Name',
        type_of_integration: 'Integration Type',
        actions: 'Actions',
        search: 'Search',
        example: 'Payload Example',

        loads: 'Charges',
        name: 'Name',
        price: 'Price',
        stock: 'Stock',
        measurements_units: 'Measurement Units',
        grid: 'Grids',
        classifications: 'Categories',
        products: 'Products',
        status_sync: 'Status Synchronization',
        marks: 'Brands',
        orders: 'Orders',
        trigger_load: 'Trigger Charge',
        first: 'Start',
        end: 'End',
        load: 'Load',
        messenger: 'Messaging',
        others: 'Others',
        test: 'Do you want to test the integration',
        params_test: 'View this integration parameters',
        copy_params: 'Copy parameters',
        result_test: 'Integration test results',
        success_1: 'Success! The integration',
        success_2: 'was successful.',
        result_log: 'Result Log',
        copy_result: 'Copy result',
        search_result: 'Search in results',
        error_1: 'The integration',
        error_2: 'returned an error. Check the log below for more information.',

        success_food_1: 'Success! The integration',
        success_food_2: 'was successful.',
        error_food_1: 'The integration',
        error_food_2: 'returned offline.',

        integrationPrint: 'Test Connection',
      },

      reports: {
        orders: 'Orders',
        order_report: 'Order Report',
        order_list: 'Order List',
        first: 'Start',
        end: 'End',
        firstTime: 'Initial time',
        endTime: 'Final time',
        orders_between: 'Orders between',
        order_number: 'Order Number',
        date: 'Date',
        consumer: 'Consumer',
        modality: 'Modality',
        total_value: 'Value',
        cancel_order: 'Cancel order',

        products: 'Products',
        quantity: 'Quantity',
        qtt: 'Qty',
        product: 'Product',
        value: 'Value',
        total: 'Total',
        order_status: 'Order Status',
        payment_method: 'Payment method',
        billing_address: 'Billing address',
        product_value: 'Value of products',
        discount: 'Discount',
        order: 'Order',

        listened_logs: 'Here are the logs listed along with their respective actions.',
        methods: 'Methods',
        log_details: 'Log Details',

        withdraw: 'Pickup',
        delivery: 'Delivery',
        table: 'Table',
        counter: 'Counter',
        responsible_withdraw: 'Responsible for pickup',
        responsible_delivery: 'Responsible for reception',
        address_withdraw: 'Pickup address',
        address_delivery: 'Delivery address',
        seller: 'Seller',
        seller_link: 'Seller Link',
        external_code: 'External number',
        payment: 'Payment',
        internal_delivery: 'Internal Delivery',
        origin: 'Origin',
        historial: 'Order history',
        approval_moment: 'Approval date and time',
        id: 'Reservation Code',
        pluginspace: 'Hotel',
        hotel: 'Order associated with the hotel',
        document: 'Reservation Document',
        room: 'Room Code',
        status_payment: 'Payment status',
        authorization_code: 'Authorization code',
        transaction: 'Transaction ID',
        made_in: 'Performed on',
        send_method: 'Shipping method',
        send_date: 'Shipping date',
        estimated_delivery: 'Delivery forecast',
        freight: 'Freight',
        tracking_code: 'Tracking code',
        website: 'Open tracking website',
        label: 'Print shipping label',
        payment_delivery: 'Payment on delivery',
        payment_money: 'Cash payment',
        change_money: 'Change',
        label_code: 'Label',
        label_website: 'Open label website',
        declaration_code: 'Declaration',
        declaration_website: 'Open declaration website',
        height: 'Height (cm)',
        width: 'Width (cm)',
        length: 'Length (cm)',
        weight: 'Weight (kg)',
        send_text: 'Shipping method chosen by the customer: ',
        success_label: 'Your shipping label has been generated successfully.',
        continue: 'Continue',
        confirm: 'Confirm',
        change_multiple_status: 'Change status of multiple orders',
        change_status_text: 'Do you want to change the status of the orders below?',
        new_status: 'New status',
        change_status: 'Change status',

        synkar: 'Automation',
        invalid_data: 'Please select the start and end dates.',

        details: 'Details',
      },

      imports: {
        imports: 'Imports',
        import_image_product: 'Image Imports for Products',
        import_image_category: 'Image Imports for Categories',
        listened_import_product:
          'Here are the image imports for products listed along with their respective actions.',
        no_upload_images: 'Do not perform image upload',
        first: 'Start',
        end: 'End',
        total_products: 'Total Products',
        sync_products: 'Synchronized Products',
        import_image_sku: 'Image Imports for Variations',
        listened_import_sku:
          'Here are the image imports for variations listed along with their respective actions.',
        verify_verification: 'Variation verification',
        product_code: 'Product code',
        code: 'Code',
        total_variations: 'Total Variations',
        sync_variations: 'Synchronized Variations',
        total_categories: 'Total Categories',
        sync_categories: 'Synchronized Categories',
        problem_title: 'Images with problem',
        images_success: 'images were sent successfully.',
        images_error: 'images presented a problem and were not sent.',
        file: 'File',
        status: 'Import status',
        new_import: 'Perform new import',
        import_xls: 'Import images with XLS file',
        import_repo: 'Import images from Google Drive or Dropbox',
        steps: 'Step by step for import',
        step_1: '1. Put all images on a public web server.',
        step_2: '2. Check if the server is public and accessible via web.',
        step_3: '3. Download our blank XLSX file.',
        step_4: '4. Fill in with your image bank data.',
        step_5: '5. Upload the filled file.',
        step_1_repo: '1. Check if the store folder is created as "fotos_loja_<store_identifier>".',
        step_2_repo: '2. Create the "produtos" folder inside your store folder.',
        step_2_repo_sku: '2. Create the "variacoes" folder inside your store folder.',
        step_2_repo_category: '2. Create the "categorias" folder inside your store folder.',
        step_3_repo: '3. Confirm if the files are as "<product_code>.<extension>".',
        step_3_repo_sku: '3. Confirm if the files are as "<sku>.<extension>".',
        step_3_repo_category: '3. Confirm if the files are as "<category_code>.<extension>".',
        step_4_repo: '4. If it is an additional product, check if it has "_<number>".',
        step_4_repo_sku:
          '4. Confirm that the variation is an image and is in JPG or PNG extension.',
        step_4_repo_category:
          '4. Confirm that the category is an image and is in JPG or PNG extension.',
        step_5_repo: '5. Confirm that the product is an image and is in JPG or PNG extension.',
        download: 'Download the blank XLSX file',
        download_problems: 'Export report',
        upload: 'Send file',
        upload_anex: 'Attach file',
        import_dropbox: 'Import with Dropbox',
        import_drive: 'Import with Google Drive',
        spreadsheet: 'Spreadsheet',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: 'Type',
        type_resize: 'Resize Type',
        agroup_color: 'Group photos by color',
        banner_size: 'Treat N1 category as banner',
        select_dimensions: 'Select the dimensions',
        square: 'Treat as 640x640',
        vertical: 'Treat as 600x900',
      },

      sms: {
        sms: 'SMS',
        listened_sms: 'Here are the messages (SMS) listed along with their respective actions.',
        order: 'Order',
        name: 'Name',
        message: 'Message',
        markers: 'The markers [pedido] and [status] must be in the message',
        waiting: 'Waiting',
        opened: 'Open',
        ready: 'Ready',
        refused: 'Refused',
      },

      multichannel: {
        multichannel: 'Multichannel',
        listened_multichannel:
          'Here are the multichannel configurations listed along with their respective actions.',
      },

      feed: {
        content: 'Content',
        title: 'Title',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Fill in the information below and click the create button to save the changes',
      },
      feedCategory: {
        feedCategory: 'Content Category',
      },

      structured_content: {},

      queue: {
        index: 'Waiting Queue',
        menage: 'Management',
        config: 'Waiting Queue Configurations',
        able: 'Allow waiting queue',
        link: 'Waiting Queue Link:',
        limit_people: 'Maximum number of people',
        limit_people_text: 'Waiting queue limit',
        limit_time: 'Time limit to display alert',
        limit_time_text: 'Maximum time in minutes to consider overdue',
        image_title: 'Image definition',
        image_text:
          'The queue system displays 2 images. Upload photos of your restaurant, or select default photos below. The photos sent will be adjusted to the size of 350x250 pixels.',
        image: 'Image',
        position: 'Position',
        time: 'Waiting time',
        people: 'people',
        cancel: 'Cancellation',
        cancel_text: 'Do you want to remove this person from the waiting queue?',
        cancel_button: 'Remove',
        confirm: 'Confirmation',
        confirm_text: 'Do you want to confirm the arrival of the booker?',
        confirm_button: 'Confirm arrival',
        empty: 'There is no waiting list at the moment',
        confirm_all: 'Confirm all',
        cancel_all: 'Cancel all',
        observation: 'Observation',
        use_terms: 'Activate consent terms',
        total_people: 'Total people per group',
        total_people_text: 'Waiting queue limit per group',
        all: 'All',
        in_queue: 'In queue',
        preferential: 'Preferential',
        confirmed: 'Confirmed',
        removed: 'Refused',
        show: 'Display',
        show_text: 'Last @ hours',
        yes: 'Yes',
        no: 'No',
        add: 'Add Customer to Queue',
        use_location: 'Allow location?',
        use_menu: 'Do you want to use a menu?',
        use_ninegrid_menu: 'Use the Ninegrid menu?',
        external_menu_link: 'Provide the menu link',
        edit: 'Edit Customer in Queue',
      },
      booking: {
        index: 'Reservation',
        config: 'Reservation Configurations',
        able: 'Allow reservation',
        link: 'Reservation Link:',
        image_title: 'Image definition',
        image_text:
          'The reservation system displays 2 images. Upload photos of your restaurant, or select default photos below. The photos sent will be adjusted to the size of 350x250 pixels.',
        image: 'Image',
        days_week: 'Days of the week',
        booking_day: 'Allow reservations on this day?',
        booking_day_text: 'Define below the times allowed for reservations.',
        booking_day_subtext:
          'Selecting a time will define a 1 hour window. Example: by selecting 19:00 people will be able to make reservations between 19:00 and 20:00.',
        max_people: 'Maximum number of people per reservation',
        max_people_text: 'It is the maximum size of a group of people that can make a reservation',
        expiry_time: 'Maximum time until reservation expires',
        expiry_time_text: 'Time in minutes to wait for the booker to arrive',
        day_confirm: 'Require confirmation on the day',
        day_confirm_text: 'User needs to confirm the reservation on the chosen date',
        payment_confirm: 'Require advance payment in the reservation',
        value_payment_confirm: 'Value of the advance payment',
        week: 'Week',
        month: 'Month',
        year: 'Year',
        use_terms: 'Activate consent terms',
        empty: 'No reservations at the moment',
        use_time: 'Allow reservation by period',
        time: 'Reservation duration (HH:mm)',
        time_cancel: 'Deadline for reservation cancellation (HH:mm)',
        time_change: 'Deadline for reservation change (HH:mm)',
        use_change: 'Allow reservation time change',
      },
      booking_day: {
        booking: 'Day Reservations',
        date: 'Date',
        people: 'people',
        expiry: 'Expires in',
        cancel_title: 'Cancellation',
        cancel_subtitle: 'Do you want to cancel this reservation?',
        cancel_button: 'Cancel reservation',
        confirm_title: 'Confirmation',
        confirm_subtitle: 'Do you want to confirm the arrival of the booker?',
        confirm_button: 'Confirm arrival',
        accessibility_needs: 'Accessibility Need',
        accessibility_elderly: 'Elderly Support',
        accessibility_wheelchair: 'Wheelchair User',
        accessibility_physical: 'Physical Disability',
        filter_accessibility: 'Filter by Accessibility',
        all_accessibility: 'All accessibility needs',
      },
      booking_report: {
        report: 'Reports',
        search: 'Reservation search',
        time: 'Select the period',
        date_start: 'Start date',
        date_end: 'End date',
        confirm: 'Confirmation',
        noShow: 'No show',
        confirmed: 'Confirmed reservations',
        canceled: 'Canceled reservations',
        open: 'Open',
        map: 'Reservation map',
        booking: 'reservations',
        accessibility_stats: 'Accessibility Statistics',
        accessibility_total: 'Total with needs',
        accessibility_percentage: 'Percentage',
      },
      booking_report_management: {
        management: 'Reservation Management',
        search: 'Reservation search',
        phone: 'Phone',
        date_start: 'Start date',
        date_end: 'End date',
        today: 'Today',
        tomorrow: 'Tomorrow',
        calendar: 'Calendar',
        see_all: 'View all',
        people: 'people',
        noShow: 'No show',
        confirmed: 'Confirmed',
        canceled: 'Cancelled',
        open: 'Open',
        search_text: 'Results by phone search or date selection',
      },
      environment: {
        map: 'Environment map',
        environment: 'Environment',
        index: 'Environments',
        name: 'Environment name',
        tables: 'Number of tables',
        seats_available: 'Total available seats',
        actions: 'Actions',
      },
      week_day: {
        sun: 'Sunday',
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thur: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
      },
      week_day_full: {
        sun: 'Sunday',
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thur: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
      },
      checkout: {
        title: 'Customer Data',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Here are the fields required for customer creation.',
        active_mandatory: 'Mandatory Field',
        active_visibility: 'Visible Field',
      },

      liveShop: {
        liveShop: 'Live Commerce',
        liveShop_list:
          'Here are the Live Commerce events listed along with their respective actions.',
        create: 'Create Live Commerce',
        edit: 'Edit Live Commerce',
        dateInit: 'Start',
        hourInit: 'Start Time',
        dateEnd: 'End',
        hourEnd: 'End Time',
        status: 'Status',
        initDate: 'Start Date and Time',
        fimDate: 'End Date and Time',
        name: 'Name',
        variations: 'Product Variations',
        search_products_Attentions:
          'Returned Products and Variations must have activated status, have price, stock, and image',
        alert_delete: 'It is not possible to remove a Live when it has started or ended!',
        alert_Edit: 'It is not possible to edit a Live when it has started or ended!',
        delete: 'Delete Live Commerce',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Pagseguro phone code error',
        pagseguroPaymentErrorCountry: 'Pagseguro country code error',
        pagseguroPaymentErrorEmail: 'Pagseguro email error',
        authenticatePagseguro: 'Pagseguro Authentication',
        pagseguroPayment: 'Pagseguro Payment',
        pagseguroPaymentCatch: 'Pagseguro Payment',
        pagseguroPaymentResponse: 'Pagseguro payment response',
        pagseguroPaymentTransactions: 'Pagseguro payment transaction',
        pagseguroReturnPayment: 'Pagseguro payment return',
        paymentPixPagseguro: 'Pagseguro Pix Payment',

        pagseguroPaymentGateway: 'Pagseguro payment gateway',
        getAuthPagseguroEmailSpace: 'Pagseguro Authentication by email',
        getOneApplicationClientId: 'Get Pagseguro client application',
        createAuthPagseguro: 'Create Pagseguro Authentication',
        generatePublicKeyPagseguro: 'Generate Pagseguro Public Key',
        updateCodeRedirectApplication: 'Update Pagseguro application code',
        deleteAuthPagseguroByEmail: 'Remove Pagseguro Authentication',
        createPluginconfig: 'Plugin configuration',

        //Totvs payment HUB
        refundTotvs: 'Refund via Totvs',
        refundPayCard: 'Refund via Totvs by card',
        paymentTotvs: 'Payment via Totvs',
        paymentPixTotvs: 'Pix payment via Totvs',

        //Card Structure
        sendUnregisteredCardBrands: 'Flag not found',
        cardStructure: 'Card structure',
        cardStructureInvalidPlugin: 'Invalid plugin for the gateway',
        cardStructureGatewayError: 'Card error for the gateway',
        cardStructureData: 'Card Data',
        cardStructureError: 'Card Data Error',
        cardStructureDecrypt: 'Card decryption',
        cardStructureFields: 'Card Fields',
        refundCard: 'Card Refund',

        //Status
        analysisSatusOrder: 'Order status for analysis',
        statusPayPix: 'Pix Status',

        //Antifraud
        analyseAntifraud: 'Antifraud Analysis',
        dataClearSale: 'ClearSale Data',
        statusAnalysis: 'Analysis Status',

        //stock
        addSkuInventory: 'Add to stock',
        subtractSku: 'Remove from stock',
        viewCargoHistory: 'View charge history',
        viewCargoHistoryBySku: 'View charge history by SKU',

        // Order-Pedido
        sendOrderIn: 'Order sending',
        cancelOrder: 'Cancel Order',
        sendOrder: 'Send Order',
        sendOrderRefund: 'Order Refund',
        sendOrderError: 'Error sending order',
        sendOrderResultRefund: 'Order refund result',
        sendOrderResultData: 'Order sending result',
        sendOrderAntifrud: 'Antifraud in order sending',
        sendOrderPaymentStruct: 'Order payment structure',

        sendOrderDescryptor: 'Order Decryption',
        sendOrderStatus: 'Order status',
        sendOrderConfigNotFound: 'Order sending configuration not found',
        sendOrderMandatoryCustomer: 'Order customer',
        sendOrderMandatory: 'Order mandatory structure',
        sendOrderResultGateway: 'Result of sending to gateway',
        OrderFashionService: 'Fashion order service',
        OrderFashionServiceError: 'Error in Fashion order service',
        cartOrderLive: 'Live order cart',
        cartOrderLiveError: 'Error in Live order cart',
        sendOrderErrorGeral: 'Order Error',
        sendPushNotification: 'Send push notification',

        //Pre-Order
        preOrderStatusPix: 'Pre-order status via pix',
        processQueuePreOrder: 'Pre-order queue processing',
        getAllPreOrderBySpace: 'Get all pre-orders by pluginspace',
        sendPreOrder: 'Pre-order sending',
        makeOrderTransparent: 'Order verification',
        statusPreOrder: 'Pre-order Pix Status Update',
        preOrderStatusCanceledPix: 'Cancel Pre-order via Pix',

        //Totvs Wintor
        buildOrderTotvsWinthor: 'Create Order',
        sendOrderWinthor: 'Send order to Totvs',
        sendCustomerOrderWinthor: 'Send customer to Totvs',

        //Totvs Retail
        buildOrderTotvsVarejo: 'Create Order',
        setConfimTicket: 'Ticket Confirmation',
        SyncOrderLive: 'Order Synchronization',
        ObterProdutos: 'Get Products',
        taskPrice: 'Price Charge',
        calculationPromotion: 'Promotion Calculation',
        PayloadCalcPromotion: 'Promotion Calculation Payload',

        //Totvs Fashion
        changeStatus: 'Status Change',
        sendOrderFashion: 'Send order to Totvs',
        sendCustomerFashion: 'Send customer to Totvs',
        searchPersonTotvsByCPF: 'Totvs Customer Search',
        sendErrorCustomerFashion: 'Error sending Customer to Fashion',
        buildCustomerTotvsFashion: 'Customer creation at Totvs',
        ResumeSnyOrderFashion: 'Summary sync with Fashion',
        changeStatusFashion: 'Change Status',
        buildOrderTotvsFashion: 'Create Fashion Order',

        //Totvs Food
        updateStatusOrderFoodIntegration: 'Status Change',
        buildOrderTotvsFood: 'Create Order',
        changeStatusOrderFood: 'Status Change',
        sendOrderTotvsFood: 'Send order to Totvs',
        confirmMenu: 'Menu Confirmed',
        getMenu: 'Get Totvs Menu',

        //Totvs Live
        sendCustomerLive: 'Live Customer Sending',
        sendOrderLive: 'Live Order Sending',

        //Synkar
        updateStatusOrderSynkar: 'Synkar Order Update',
        sendingOrderMessageSynkar: 'Synkar Messaging Sending',
        responseOrderMessageSynkar: 'Synkar Messaging Response',
        sendingOrderSynkar: 'Synkar Sending',
        responseOrderSynkar: 'Synkar Response',

        //SDS
        sdsGetOrders: 'Get SDS orders',
        sdsOrderIn: 'SDS Orders Sending',
        sdsOrderInResult: 'Send order to SDS',
        sdsSyncCardapio: 'Menu Sync with SDS',
        'sendOrderfood-sdsOrderIn': 'Error sending SDS order',

        //S3
        createRoute: 'Create S3 Route',
        getStatusfiftythree: 'Route 53 Status',
        updateDistribution: 'Update Distribution',
        deleteRoute: 'Delete S3 Route',
        deleteDistribution: 'Delete Distribution',

        //Erede
        refundErede: 'Erede Refund',
        paymentErede: 'Erede Payment',

        //Cielo
        refundCielo: 'Cielo Refund',
        paymentCielo: 'Cielo Payment',

        //Pagseguro
        refundPagseguro: 'Pagseguro Refund',
        getApplicationPagseguro: 'Pagseguro Application Gateway',

        //offline payment
        paymentOffline: 'Payment on delivery',

        //General
        chargeSyncOrderErro: 'Error in Status Sync',
        chargeSyncOrder: 'Status Sync',
        chargeProductLive: 'Live Product Sync',
        chargeBalanceLive: 'Live Stock Sync',
        chargePriceLive: 'Live Price Sync',
        chargeProductLiveErro: 'Error in Live Product Sync',
        chargeBalanceLiveErro: 'Error in Live Stock Sync',
        chargePriceLiveErro: 'Error in Live Price Sync',

        chargeProduct: 'Product Sync',
        chargeBalance: 'Stock Sync',
        chargePrice: 'Price Sync',
        chargeProductErro: 'Error in Product Sync',
        chargeBalanceErro: 'Error in Stock Sync',
        chargePriceErro: 'Error in Price Sync',

        taskBalanceIntegration: 'Stock Charge Integration',
        taskBalanceCharge: 'Stock charge started',
        SnyOrder: 'Order status synchronization',
        syncronyzePriceInteration: 'Price Charge',
        syncronyzePrice: 'Price Synchronization',
        chargeClassification: 'Category and subcategory Charge',
        chargeGrid: 'Grid Charge',
        chargeGridItens: 'Grid Charge Items',
        chargeMeasure: 'Measurement Unit Charge',
        deleteAllProducts: 'Delete all Products',

        chargeGridToken: 'Token for Grid Charge',
        classificationChargeToken: 'Token for Classification Charge',
        syncronyzeBalanceToken: 'Token for Stock Synchronization',
        syncronyzePriceToken: 'Token for Price Synchronization',
        chargeMeasureToken: 'Token for Measurement Unit Charge',
        taskClassificationBySpace: 'Classification Charge',
        syncStatusOrderPayload: 'Order Status Synchronization Payload',
        syncStatusOrder: 'Order Status Synchronization',
        syncStatusOrderToken: 'Order Status Synchronization Token',
        syncronyzeBalancePayload: 'Stock Synchronization Payload',
        syncronyzeBalance: 'Stock Synchronization',
        taskBalanceChargeBySpace: 'Stock Charge',
        syncronyzePricePayload: 'Price Synchronization Payload',
        priceSkuVariationItens: 'Price of Variation Items',
        configSyncOrderBySpace: 'Order Synchronization Configuration',
        configSyncOrder: 'Order Synchronization Configuration',
        taskGridChargeBySpace: 'Grid Charge',
        productChargeInternal: 'Product Charge',
        taskChargeProductBySpace: 'Product Charge',
        skuLocationVariation: 'Variation Synchronizations by Location',
        stockSkuVariation: 'Variation Synchronizations',
        taskPriceChargeBySpace: 'Price Charge by Pluginspace',

        automaticChargeBalance: 'Automatic Stock Sync',
        automaticChargePrice: 'Automatic Price Sync',
        automaticChargeClassification: 'Automatic Classification Sync',
        automaticTaskGridCharge: 'Automatic Grid Sync',
        automaticTaskMeassure: 'Automatic Meas. Unit Sync',
        automaticSnyOrder: 'Automatic Order Status Sync',
        chargeMeasureItens: 'Meas. Unit Charge Items',
        searchMeasurementAll: 'Measurement Unit Charge',
        taskGridCharge: 'Grid Charge',
        taskMeassure: 'Measurement Unit Charge',

        getCredential: 'Get Token',
        LoadPricePerList: 'Price Charge',
        processPriceList: 'Price List Processing',
        updateProductKit: 'Product Update',
        UpdateProductSingle: 'Product Update',
        updateProductStatus: 'Product Status Update',
        taskBalanceIntegrationLink: 'Stock integration link',
        taskPriceIntegrationLink: 'Price integration link',
        taskProductIntegrationLink: 'Product integration link',
        token: 'Token Acquisition',
        automaticChargeProduct: 'Automatic product charge',

        //Discount Ninegrid
        calculateDiscount: 'Discount calculation in ninegrid',
        sendDiscountNinegrid: 'Ninegrid Discount',

        //Customer Cart
        updateCustomerCartStatus: 'Customer cart update',

        //Client
        createCustomer: 'Customer Creation',
        validCodeCustomer: 'Customer validation code',

        //clearSale
        statusAnalisis: 'Status Analysis',
        antifraudValidation: 'Antifraud validation',
        clearSale: 'ClearSale Guaranteed',
        searchOrderStatusClearSale: 'Search ClearSale Status',

        printLabelFrenet: 'Frenet Label',
        changeStatusFrenet: 'Frenet status change',
        callWaiter: 'Call Waiter',
        paymentTable: 'Payment at the table',

        // Invoice Generation Chef
        generateNfOrderFood: 'Generate order invoice',
        getNotaFiscalChef: 'Retrieve Chef invoice',
        finishOrderFood: 'Pre-invoice check',

        // Chef Order Error Log
        buildCardData: 'Error creating data for Command',
        buildTableData: 'Error creating data for Table',
        buildTablePaymentData: 'Error creating data for Table Payment',
        buildCounterData: 'Error creating data for Counter',
        buildDeliveryData: 'Error creating data for Delivery/Pickup',

        generateCustomerWholeSalerByCSV: 'Generate wholesaler customer by CSV',

        validateStockWholeSaleCart: 'Order alert',
        validateWholeSaleCart: 'Order alert',

        chargeImageService: 'Image charge service',

        webhookNisRedis: 'Store Redis Cleanup',

        /*Email Sending  */
        sendEmailWelcome: 'Send welcome email',
        sendEmailOrderNotification: 'Send order email notification',
        sendEmailAccountNotification: 'Send account email notification',
        createCustomerLogin: 'Send customer login creation email',
      },

      copy: {
        definition: 'Pluginspace Definition',
        origin: 'Select the origin Pluginspace',
        destination: 'Select the destination Pluginspace',
        configurations: 'Copy Configurations',
        store: 'Store Settings',
        deliveryFee: 'Delivery Fee',
        shifts: 'Shifts',
        paymentPlans: 'Payment Plans',
        clientData: 'Customer Data',
        account: 'Account Settings',
        groups: 'Groups',
        terms: 'Terms',
        webapp: 'Webapp',
        webappConfig: 'Configurations',
        webappPersonalize: 'Personalization',
        whatsappweb: 'WhatsApp Web',
        whatsappwebConfig: 'Configurations',
        whatsappwebPersonalize: 'Personalization',
        integrations: 'Integrations',
        integrationPayment: 'Payment methods',
        integrationPdv: 'POS',
        integrationMessaging: 'Messaging',
        integrationOthers: 'Others',
        button: 'Copy Pluginspace',
      },

      payment: {
        methods: 'Payment methods',
        method: 'Payment method',
        gateway: 'Payment gateway',
        card: 'Credit card',
        debit: 'Debit card',
        food: 'Meal voucher',
        pix: 'Pix',
        others: 'Others',
        pay_money: 'Cash',
        config: 'Configurations',
        add: 'Configure payment method',
        back: 'Back to payment gateways',
        basic_settings: 'Basic settings',
        modalities: 'Modalities where this payment method will be used',
        add_payment: 'Add payment method',
        code_erp: 'ERP Code',
        installments: 'Number of installments',
        edit_payment: 'Edit payment method',
        delete: 'Delete payment method',
        money: 'Cash payment',
        max_installments: 'What is the maximum number of installments?',
        min_value_installments: 'What is the minimum value for installments?',
        confirm: 'Confirm exclusion',
        delete_payment: 'Do you want to delete the payment method',
        change: 'Do you want to perform this exchange?',
        inative: 'Do you want to inactivate this payment method?',
        inative_change: 'Do you want to activate this payment method and inactivate the old one?',
        motive: 'Please inform the reason',
        /* usado para desconto */
        config_descount_payment: 'Discount configuration by payment method',

        able_discount_pix: 'Enable discount for Pix payment',
        able_discount_card: 'Enable discount for Card payment',
        able_discount: 'Enable discount for payment',

        discount_percentage: 'Percentage Discount',
        discount_monetary: 'Monetary Discount',
        discount_value: 'Discount Value',
      },

      icon: {
        title: 'Icons',
        subtitle: 'Here are all the library icons listed',
      },
      freight: {
        title: 'Shipping Modalities',
        map: 'Map',
        map_text: 'Option for payment on delivery of the order',
        range: 'Radius',
        range_text: 'Option for payment on delivery of the order',
        cep: 'Zip Code List',
        cep_text: 'Option for payment on delivery of the order',
        config: 'Configurations',
        delivery: 'Own delivery',
        delivery_text: 'There are 3 customizable delivery options:',
        frenet: 'Frenet',
        frenet_text: 'Complete freight management with several carriers and shipping means.',
        frenet_text_2: 'To enable this integration it is necessary to have a Frenet plan.',
        site: 'View the official website',
        coming_soon: 'Coming soon...',
      },
      frenet: {
        title: 'Integration with Frenet',
        back: 'Back to shipping methods',
        integration: 'Integration',
        config: 'Configurations',
        dimensions: 'Basic shipping dimensions in centimeters',
        height: 'Height',
        width: 'Width',
        length: 'Length',
        value: 'Declared value of products',
        use: 'Use',
        dont_use: 'Do not use',
        price: 'Use simplified quotation?',
        yes: 'Yes',
        no: 'No',
        branchCode: 'Jadlog posting point',
        no_balance: 'No balance in Frenet',
        value_balance: 'You have @ balance in Frenet',
        print_balance:
          'To print the shipping label for this order it is necessary to load balance on your Frenet account.',
        click_balance: 'Click the button below to access Frenet in another tab.',
        open_balance: 'Open Frenet account',
        valid_token: 'Invalid Token',
        declared_value: 'The declared value is used in case of insurance by the carrier.',
        getToken:
          'To find the token in Frenet, it is necessary to access the access keys section and copy the value of the "TOKEN" field.',
        weight_frenet: 'Standard weight (kg)',
        height_frenet: 'Standard height (cm)',
        width_frenet: 'Standard width (cm)',
        depth_frenet: 'Standard depth (cm)',
        alert_title: 'Reference dimensions for freight calculation',
        alert_warning: 'Attention!',
        alert_description:
          'These measures will be used to calculate the freight of products without registered volumetric size.',
        alert_wrong_values: 'Incorrect values can generate:',
        alert_overpriced: 'Overcharged freights (driving customers away).',
        alert_additional_costs: 'Additional costs (if the carrier adjusts the value later).',
        alert_recommendation:
          'We recommend registering the actual volumetric size of each product.',
        alert_reference: 'Reference dimensions:',
        alert_small_products: 'Small products',
        alert_small_examples: '(ex: accessories, costume jewelry, cables)',
        alert_small_weight: 'Weight: 0.1–0.3 kg',
        alert_small_dimensions: 'Dimensions: 10 × 10 × 5 cm',
        alert_medium_products: 'Medium products',
        alert_medium_examples: '(ex: clothes, books, small electronics)',
        alert_medium_weight: 'Weight: 0.5–2 kg',
        alert_medium_dimensions: 'Dimensions: 25 × 20 × 10 cm',
        alert_large_products: 'Large products',
        alert_large_examples: '(ex: home appliances, bulky boxes)',
        alert_large_weight: 'Weight: 5–20 kg or more',
        alert_large_dimensions: 'Dimensions: 50 × 40 × 30 cm or greater',
      },
      chat: {
        you: 'You',
        now: 'Sent now',
        send: 'Send',
        type_message: 'Send a message...',
        initial_message: 'Welcome to Ninegrid AI chat',
        error_message:
          "I couldn't find an answer to your message, please be more specific or try again later.",
        tip_language: 'Please reply in English.',
        title_config: 'Artificial Intelligence Configurations',
        config: 'Configure Artificial Intelligence',
        fit: 'Artificial Intelligence Training',
        fit_header: 'Here are the questions listed with the respective created answers',
        add_question: 'Add question',
        edit_question: 'Edit question',
        delete_question: 'Do you want to delete the question below?',
        question: 'Question',
        answer: 'Answer',
        date: 'Date',
        actions: 'Actions',
        active: 'Active',
        delete: 'Delete',
        sync: 'Sync AI',
        upload: 'File Upload',
        about: 'About',
        chatia: 'Chat',
        about_title: 'About Ninegrid AI',
        about_description_title: 'Description',
        about_description:
          'Ninegrid AI is an intelligent virtual assistant designed to help you with support tasks.',
        about_support_title: 'Support',
        about_support_description:
          'If you have any questions or need help, our support team is ready to assist you.',
        about_support_contact_1: 'To speak with support, contact us by e-mail',
        about_support_contact_2: 'or open a ticket on our portal:',
        about_features_title: 'Features',
        tips: 'Tips for creating your questions',
        about_tips_1: 'Use clear and objective questions to get better answers.',
        about_tips_2: 'Avoid slang or complex technical terms.',
        about_tips_3: 'If the answer is not satisfactory, try rephrasing the question.',
        about_tips_4:
          'Ninegrid AI learns from interactions, so the more you use it, the better it will get.',
        feature_1: 'Natural language conversation',
        feature_2: 'Voice command support',
        feature_3: 'Voice synthesis for answers',
        feature_4: 'Intuitive and responsive interface',
        about_manuals: 'Manuals',
        about_manuals_description:
          'Check out our manuals to learn more about how to use the Ninegrid Environment,',
        about_faq: 'Frequently Asked Questions',
        about_faq_description:
          'See the most frequent questions and their answers to clarify common doubts,',
        about_version_title: 'System Information',
        version: 'Version',
        last_update: 'Last update',
        rights_reserved: 'All rights reserved',
        access_here: 'access here',
        our_faq: 'see the frequent questions',
        or: 'or',
        and: 'and',
      },
      sumary_access: {
        cart: 'Cart',
        seller: 'Seller Login',
        category: 'Categories',
        pdv: 'Product Details',
        subcategory: 'Subcategory',
        product: 'Product List',
        home: 'Initial Screen',
        'search-order': 'Orders',
        'store-info': 'Store Information',
        customer: 'Customer registration',
        receipt: 'Payment receipt',
        order: 'Payment',
        card: 'Card Payment',
        'order-qrcode': 'Pix Customer Payment',
        'success-order': 'Purchase Success',
        'filter/pdv': 'Filters Result',
        filter: 'Filter Selection',
        'seller-qrcode': 'Payment Link',
        'vendor-order ': 'Seller cart consultation',
        'finalize-order': 'Purchase Summary',
      },
      optional: {
        optionals: 'Add-ons',
        list: 'Add-ons List',
        name: 'Name',
        used: 'Used in',
        config: 'Configure',
        link: 'Associate products',
        products_optional: 'Products associated with the list',
        edit: 'Edit add-ons list',
        type: 'Selection type',
        max: 'Maximum',
        mandatory: 'Mandatory',
        order: 'Order',
        code: 'Code',
        qtd: 'Max Qty',
        price: 'Price',
        include: 'Include an add-on',
        create: 'Create add-ons list',
        description: 'Webapp description',
        emptyProduct: 'No product is using this add-on',
      },

      coupons: {
        title: 'Coupons',
        report: 'Coupon Reports',
        titleCreate: 'Create Coupons',
        titleUpdate: 'Edit Coupons',
        subTitle: 'Here are the coupons listed along with their respective actions.',
        create: 'Create Coupon',
        edit: 'Edit Coupon',
        delete: 'Delete Coupon',

        //variaveis do input
        name: 'Coupon Name',
        name_helper: 'Maximum 15 characters',
        description: 'Description',
        description_placeholder: 'should accept a maximum of 200 characters',
        seller: 'Seller',
        catalog: 'Catalog',
        discountValue: 'Discount Value',
        discountPercentage: 'Discount Percentage',
        type: 'Type',
        dateInit: 'Start date',
        dateEnd: 'End date',
        quantitative: 'Quantity of uses',
        // typeOptions defined above
        filters: 'Filters',
        status: 'Status',
        selectStatuses: 'Select statuses',
        actions: {
          filter: 'Filter',
          export: 'Export',
        },
        quick: {
          today: 'Today',
          week: 'This Week',
          month: 'This Month',
          lastMonth: 'Last Month',
          year: 'This Year',
        },
        stats: {
          title: 'General Statistics',
          totalCoupons: 'Total Coupons',
          activeCoupons: 'Active Coupons',
          totalUsages: 'Total Usages',
          totalDiscount: 'Total Discounted',
        },
        distribution: {
          title: 'Distribution by Type',
        },
        monthlyUsage: {
          title: 'Monthly Usage',
        },
        series: {
          usageCount: 'Usage Count',
          numberOfUses: 'Number of Uses',
          discountValue: 'Discount Value',
        },
        table: {
          details: 'Coupon Details',
        },
        statusLabels: {
          true: 'Active',
          false: 'Inactive',
        },
        statusOptions: {
          all: 'All',
          active: 'Active',
          inactive: 'Inactive',
          expired: 'Expired',
        },
        typeOptions: {
          all: 'All Types',
          classification: 'Classification',
          product: 'Product',
          individuality: 'Individual',
          exclusive: 'Exclusive',
          quantitative: 'Quantitative',
          periodical: 'Periodical',
          cupomday: 'Coupon Day',
        },
      },

      order_print: {
        title: 'Check order information before confirming printing',
        print_text: 'Print',
        information:
          'QZ Tray will request permission to establish the connection. Click "Allow" to proceed with printing.',
        order_details: 'Order Details',
        client: 'Customer',
        payment: 'Payment',
        created: 'Created',
        print: 'Print Order',
        print_confirm:
          'Do you want to print this order? Make sure the printer is connected and configured correctly before proceeding',
      },

      whatsappweb: {
        title: 'WhatsApp Web',
        subtitle:
          'Here are the WhatsApp configurations listed along with their respective actions.',
        titleCreate: 'Sync WhatsApp',
        titleDelete: 'Remove WhatsApp Sync',
        create: 'Sync WhatsApp',
        delete: 'Delete WhatsApp Session',
        active: 'Active',
        welcome: 'Ninegrid WhatsApp Web',
        describe_whatsappweb:
          "Here it is possible to link WhatsAppWEB with the store's cell phone!",
        config: 'To configure WhatsApp',
        step1: 'Open WhatsApp on your cell phone.',
        step2: 'Tap More options ⋮ on Android or Settings ⚙️ on iPhone.',
        step3: 'Tap Linked devices and then Link a device.',
        step4: 'Point your cell phone at this screen to scan the QR code.',
      },
      fileManagement: {
        title: 'File Management',
        subtitle: 'Here are the files listed along with their respective actions.',
        create: 'Create File',
        edit: 'Edit File',
        delete: 'Delete File',
        download: 'Download File',
        upload: 'Send File',
        file: 'File',
        file_name: 'File Name',
        file_item: 'Item',
        file_itens: 'Items',
        file_type: 'File Type',
        file_size: 'File Size',
        file_date: 'Creation Date',
        file_actions: 'Actions',
        file_folder: 'Folder',
        file_new_folder: 'New Folder',
        file_folder_name: 'Folder Name',
        file_last_modified: 'Last Modified',
        file_description: 'File Description',
        file_description_placeholder: 'File description',
        file_description_helper: 'Maximum 200 characters',
        file_name_placeholder: 'File name',
        file_name_helper: 'Maximum 15 characters',
        file_page_showing: 'Showing',
        file_not_found: 'No file found',
        file_uploading: 'Loading file',
        file_upload: 'Load File',
        file_changing: 'Changing file',
        file_Loading: 'Loading files',
        file_update: 'Update',
        file_sync_knowledge_base: 'Sync Knowledge Base',
        file_history_sync: 'Synchronization History',
        scanned: 'Scanned',
        indexed: 'Indexed',
        modified: 'Modified',
        completed: 'Completed',
        deleted: 'Deleted',
        failed: 'Failed',
        available: 'Available',
        last_update: 'Last update',
        status: 'Status',
        status_job: 'Task Status',
        data_source: 'Data Source',
        knowledge_base: 'Knowledge Base',
        history_sync: 'Synchronization History',
        chart_scanned_doc: 'Scanned Documents',
        chart_indexed_doc: 'Indexed Documents',
        chart_modified_doc: 'Modified Documents',
        chart_deleted_doc: 'Deleted Documents',
        chart_failed_doc: 'Failed Documents',
        chart_docs_processed: 'Processed Documents',
        chart_docs_total: 'Total Documents',
        total_jobs_processed: 'Total Processed Tasks',
        jobs_info: 'Information about the Tasks',
        observation_table_jobs_phase:
          'Processed Jobs Table presents the last 5 jobs from each data source.',
      },
      service_requests: {
        title: 'Service Forms',
        subtitle: 'Manage service request forms',
        create: 'Create Service Form',
        edit: 'Edit Service Form',
        delete: 'Delete Service Form',
        create_form: 'Create Form',
        edit_form: 'Edit Form',
        delete_form: 'Delete Form',
        form_title: 'Title',
        form_icon: 'Icon',
        form_status: 'Status',
        form_description: 'Description',
        form_components: 'Components',
        form_grids: 'Grids',
        priority_label: 'Priority',
        priority_low: 'Low',
        priority_normal: 'Normal',
        priority_high: 'High',
        priority_critical: 'Critical',
        choose_icon: 'Choose',
        add_component: 'Add',
        sections: 'Sections',
        empty_message: 'Click Add to insert components and drag to reorder.',
        success_created: 'The service form was created successfully.',
        success_updated: 'The service form was updated successfully.',
        success_deleted: 'Service form deleted successfully.',
        error_create: 'An error occurred while creating the service form.',
        error_update: 'An error occurred while updating the service form.',
        error_delete: 'Error deleting the service form.',
        error_load: 'Error loading!',
        validation_title: 'Please, inform a title for the session',
        validation_icon: 'Please, choose an icon for the session',
        validation_components: 'Add at least one component before saving',
        placeholder_title: 'Ex.: Cleaning',
        icon_selected: 'Selected icon (SVG)',
        icon_none: 'No icon selected',
        visual_instructions:
          'Visually assemble the session. Drag to reorder. The fields are visual only (non-interactive).',
        component: 'component',
        components_plural: 'components',
        grid: 'grid',
        grids_plural: 'grids',
        grid_services: 'Service Grids',
        grid_services_title: 'Select Service Grids',
        grid_services_search: 'Search grids',
        grid_services_label: 'Grids',
        grid_services_selected: 'Selected Grids',
        grid_services_error: 'Error searching hotel grids',
        add_component_modal: 'Add component',
        validation_grids_required: 'Mandatory Grids',
        validation_grids_text:
          'All selection components must have at least one service grid selected.',
        actions: 'Actions',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_essential_services: 'Essential Services',
        // UI Elements
        drag_title: 'Drag',
        drag_action: 'Drag',
        remove_title: 'Remove',
        remove_aria_label: 'Remove block',
        max_quantity_title: 'Maximum quantity:',
        max_prefix: 'Max:',
        description_label: 'Description',
        sections_label: 'Sections',
        // Modal titles and actions
        select_icon_title: 'Select',
        no_icons_available: 'There are no icons available…',
        search_placeholder: 'Type to search...',
        grid_services_selected_label: 'Selected:',
        no_grid_found: 'No grid found',
        no_grid_available: 'No grid available',
        grid_status_active: 'Active',
        grid_status_inactive: 'Inactive',
        grid_item_name_placeholder: 'Name (e.g.: Relaxing Massage)',
        grid_item_value_placeholder: 'Value (e.g.: 50.00)',
        cancel_button: 'Cancel',
        save_button: 'Save',
        confirm_button: 'Confirm',
        // Quantity modal
        max_quantity_modal_title: 'Define Maximum Quantity',
        max_quantity_label: 'Maximum quantity',
        max_quantity_placeholder: 'Enter the maximum quantity',
        max_quantity_helper:
          'Defines the maximum number of items that can be selected in this field.',
        // Breadcrumbs
        breadcrumb_create: 'Create',
        breadcrumb_edit: 'Edit',
        // Form components
        sample_service_1: 'Service 1',
        sample_service_2: 'Service 2',
        sample_hygiene: 'Hygiene',
        sample_drinks: 'Drinks',
        room_number_label: 'Room number',
        select_placeholder: 'Select...',
        date_label: 'Date',
        hour_label: 'Hour',
        quantity_label: 'Quantity',
        between_placeholder: 'Between',
        and_placeholder: 'and',
        select_list_label: 'Selection (list)',
        select_item_placeholder: 'Select an item',
        select_checkbox_label: 'Selection (checkbox)',
        // Visibility
        visible_to_label: 'Visible to',
        visible_to_employees: 'Employees',
        visible_to_customers: 'Customers',
        visible_to_both: 'Both',
        select_category_placeholder: 'Select a category',
        select_quantity_label: 'Selection (quantity)',
        qty_label: 'Qty.',
        // Catalog titles
        catalog_room_number: 'Room number',
        catalog_date: 'Date',
        catalog_hour: 'Hour',
        catalog_date_hour: 'Date + Hour',
        catalog_select_list: 'Selection (list)',
        catalog_select_list_quantity: 'Selection (List) + Quantity',
        catalog_select_checkbox: 'Selection (checkbox)',
        catalog_select_count: 'Selection (quantity)',
        catalog_quantity: 'Quantity',
      },
      base_modal: {
        attention_title: 'Attention!',
        unsaved_changes_text: 'The changes made will be lost, are you sure you want to leave?',
        confirm_button: 'Yes',
        cancel_button: 'No',
      },
      summarize_ia: {
        title: 'AI Utilization Summary',
        subtitle: 'Here is the AI summarization information listed.',
        create: 'Create AI Summarization',
        edit: 'Edit AI Summarization',
        delete: 'Delete AI Summarization',
        summarize: 'Summarize',
      },
      hospitality: {
        add_room: 'Add Room',
        create_multiples: 'Create Multiples',
        add_activity: 'Add Activity',
        add_experience: 'Add Experience',
        experiences: 'Experiences ',
        experience_type: 'Experience Type',
        experience_duration: 'Duration',
        experience_price: 'Price',
        experience_rating: 'Rating',
        experience_includes: 'Includes',
        create_experience: 'Create Experience',
        edit_experience: 'Edit Experience',
        experience_created: 'Experience created successfully!',
        experience_updated: 'Experience updated successfully!',
        experience_deleted: 'Experience deleted successfully!',
      },
      hospitality_content: {
        page_title: 'Buttons',
        page_subtitle: 'The buttons for the sections are listed here.',
        add_button: 'Add Button',
        filters: {
          sections: 'Sections',
        },
        table: {
          headers: {
            title: 'Title',
            order: 'Order',
            formTitle: 'Form Title',
            type: 'Type',
            visibility: 'Visibility',
            actions: 'Actions',
          },
        },
        tabs: {
          buttons: 'Buttons',
          native_buttons: 'Native Buttons',
        },
        actions: {
          edit: 'Edit button',
          delete: 'Delete button',
          delete_confirm: 'Are you sure you want to delete this button?',
        },
        type_labels: {
          service_form: 'Service Forms',
          feedback: 'Your Feedback',
          service: 'Services',
          information: 'Information',
          activities_leisure: 'Activities and Leisure',
          bars_restaurants: 'Bars and Restaurants',
          schedule: 'Programming',
          experience: 'Experience',
          booking: 'Schedules',
          check_in: 'Check-in',
          check_out: 'Check-out',
          tours: 'Tours',
          page_dynamic: 'Dynamic Page',
        },
        no_category: 'No category',
        messages: {
          filter_error_title: 'Error',
          filter_error_text: 'Error filtering sections',
          load_error_title: 'Load Error',
          load_error_text: 'Failed to load sections!',
          section_not_found_title: 'Error',
          section_not_found_text: 'Section not found!',
          deleted_title: 'Section Deleted',
          deleted_text: 'Deletion performed successfully!',
          delete_error: 'Error deleting section!',
          visibility_updated_title: 'Visibility Updated',
          visibility_updated_text: 'Button visibility updated successfully!',
          visibility_error_title: 'Update Error',
          visibility_error_text: 'Error updating button visibility!',
          form: 'Form',
          page: 'Page',
        },
        create_modal: {
          modal_title: 'Add Content',
          alert_title: 'Section and Content Selection',
          alert_subtitle: 'Select the corresponding section and content.',
          label_section: 'Section',
          label_content: 'Content',
          placeholder_select: 'Select',
          placeholder_select_section: 'Select the section',
          placeholder_select_content: 'Select the content',
          order_label: 'Order',
          selection_summary: 'Selection summary:',
          badge_section: 'Section',
          badge_content: 'Content',
          select_form_label: 'Select the form (roomService)',
          tips_title: 'Tips',
          tips: {
            item1: 'The section can have multiple contents',
            item2: 'The content can belong to multiple sections',
            item3: 'The order defines the position in the listing',
          },
          buttons: {
            cancel: 'Cancel',
            create: 'Create',
          },
          swal: {
            missing_field_title: 'Missing field',
            missing_section: 'Select a section to continue',
            missing_content: 'Select content to continue',
            invalid_field_title: 'Invalid field',
            invalid_order: 'Order must be a positive number or zero',
            created_title: 'Content registered',
            created_text: 'Registration completed successfully!',
            create_error: 'Error registering content!',
          },
        },
        edit_modal: {
          modal_title: 'Edit Content',
          alert_title: 'Content Editing',
          alert_subtitle:
            'Change the section and order as necessary. The current content cannot be changed.',
          label_section: 'Section',
          label_content: 'Content',
          placeholder_select: 'Select',
          placeholder_select_section: 'Select the section',
          placeholder_select_content: 'Select the content',
          order_label: 'Order',
          selection_summary: 'Selection summary:',
          badge_section: 'Section',
          badge_content: 'Content',
          tips_title: 'Tips',
          tips: {
            item1: 'You can only change the section',
            item2: 'The order defines the position in the listing',
          },
          buttons: {
            cancel: 'Cancel',
            save: 'Save',
          },
          swal: {
            missing_field_title: 'Missing field',
            missing_section: 'Select a section to continue',
            missing_content: 'Select content to continue',
            invalid_field_title: 'Invalid field',
            invalid_order: 'Order must be a positive number or zero',
            updated_title: 'Content updated',
            updated_text: 'Update completed successfully!',
            update_error: 'Error updating content!',
          },
        },
        category: {
          page_title: 'Sections',
          page_subtitle:
            'The content sections are listed here along with their respective actions.',
          add_button: 'Add',
          breadcrumbs: {
            dashboard: 'Dashboard',
            categories: 'Categories',
          },
          table: {
            headers: {
              section: 'Section',
              order: 'Order',
              status: 'Status',
              actions: 'Actions',
            },
          },
          options: {
            edit_category: 'Edit category',
            delete_section: 'Delete section',
            delete_confirm: 'Delete section',
          },
          swal: {
            deleted_title: 'Section deleted',
            deleted_text: 'Deletion completed successfully!',
            delete_error: 'Error deleting section!',
          },
          create: {
            missing_fields_title: 'Missing fields',
            missing_fields_text: 'Check if you have filled in all fields correctly!',
            created_title: 'Category registered',
            created_text: 'Registration completed successfully!',
            create_error: 'Error registering the category!',
          },
          update: {
            missing_fields_title: 'Missing fields',
            missing_fields_text: 'Check if you have filled in all fields correctly!',
            updated_title: 'Category updated',
            updated_text: 'Editing completed successfully!',
            update_error: 'Error updating the category!',
          },
          type: {
            default: 'Default',
            banner: 'Featured Banner',
          },
        },
      },
      clean_safe: {
        title: 'Clean & Safe',
        subtitle: 'Manage safety measures, cleaning protocols, and certifications',
        security_measures: 'Safety Measures',
        cleaning_protocols: 'Cleaning Protocols',
        certifications: 'Certifications',
        add_security_measure: 'Add Measure',
        add_cleaning_protocol: 'Add Protocol',
        add_certification: 'Add Certification',
        add_new_security_measure: 'Add New Measure',
        add_new_cleaning_protocol: 'Add New Protocol',
        add_new_certification: 'Add New Certification',
        security_measure: 'Safety Measure',
        cleaning_protocol: 'Cleaning Protocol',
        certification: 'Certification',
        icon: 'Icon',
        choose_icon: 'Choose Icon',
        title_field: 'Title',
        description: 'Description',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        remove: 'Remove',
        save: 'Save',
        required_title: 'Title is mandatory',
        required_icon: 'Icon is mandatory',
        required_fields: 'Mandatory fields',
        required_fields_message: 'Please, fill in all mandatory fields.',
        confirmation: 'Confirmation',
        delete_security_measure_confirm: 'Are you sure you want to delete this safety measure?',
        delete_cleaning_protocol_confirm: 'Are you sure you want to delete this cleaning protocol?',
        delete_certification_confirm: 'Are you sure you want to delete this certification?',
        yes: 'Yes',
        no: 'No',
        error: 'Error',
        error_delete: 'Error deleting item.',
        success: 'Success',
        success_save: 'Hygiene and safety data saved successfully!',
        error_save: 'An error occurred while saving the data.',
        empty_security_measures: 'No safety measure added yet.',
        empty_cleaning_protocols: 'No cleaning protocol added yet.',
        empty_certifications: 'No certification added yet.',
        empty_start_message: 'Click on "Add" to start.',
        placeholder_security_title: 'Enter the safety measure title',
        placeholder_protocol_title: 'Enter the protocol title',
        placeholder_certification_title: 'Enter the certification title',
        placeholder_security_description: 'Enter a brief description (maximum 100 characters)',
        placeholder_protocol_description: 'Enter the detailed description of the cleaning protocol',
      },
      orders_room_service: {
        title: 'Room Orders',
        subtitle: 'Hotel service request management',

        // Filters
        status: 'Status',
        start_date: 'Start Date',
        end_date: 'End Date',
        reservation_id: 'Reservation Code',
        post_id: 'Post ID',
        service_type: 'Service Type',
        search: 'Search',
        clear_filters: 'Clear Filters',

        // Status
        status_pending: 'Pending',
        status_confirmed: 'Confirmed',
        status_in_progress: 'In Progress',
        status_cancelled: 'Cancelled',
        status_concluded: 'Concluded',
        status_completed: 'Completed',

        // Filter options
        all_status: 'All statuses',
        all_types: 'All types',
        service_forms: 'Service Forms',
        services: 'Services',

        // Table Headers
        service: 'Service',
        room: 'Room',
        price: 'Price',
        people_qty: 'Number of People',
        reservation: 'Reservation',
        date: 'Date',
        time: 'Time',
        priority: 'Priority',
        created_at: 'Created On',
        actions: 'Actions',

        // Tooltip actions
        view_details: 'View Details',
        change_status: 'Change Status',

        // Details Modal
        order_details: 'Order Details',
        close: 'Close',
        loading_details: 'Loading order details...',
        loading: 'Loading...',

        // Order Information
        order: 'Order',
        room_service: 'Room Service',
        location: 'Location',
        room_number: 'Room Number',
        scheduled_date: 'Scheduled Date',
        no_time: 'No time',
        reservation_id_label: 'Reservation Code',

        // Customer Information
        customer_info: 'Customer Information',
        full_name: 'Full Name',
        email: 'E-mail',
        phone: 'Phone',

        // Request Details
        request_summary: 'Request Summary',
        service_details: 'Service Details',
        request_details: 'Request Details',
        no_items_selected: 'No items selected',
        not_informed: 'Not informed',
        units: 'units',

        // Technical Information
        technical_info: 'Technical Information',
        post: 'Post',
        booking_type: 'Booking Type',
        hotel_info: 'Hotel Information',
        hotel_name: 'Hotel Name',
        subdomain: 'Subdomain',
        type: 'Type',
        service_form: 'Service Form',
        last_update: 'Last Update',
        additional_notes: 'Additional Observations',

        // Status Change Modal
        change_status_title: 'Change Status',
        current_status: 'Current Status',
        new_status: 'New Status',
        select_status: 'Select a status',

        // Placeholders
        select_status_placeholder: 'Select status',
        select_service_type_placeholder: 'Select service type',
        start_date_placeholder: 'Start date',
        end_date_placeholder: 'End date',
        reservation_id_placeholder: 'Enter reservation ID',
        post_id_placeholder: 'Enter post ID',
        new_status_placeholder: 'Select new status',

        // Error and Success Messages
        error: 'Error',
        success: 'Success',
        warning: 'Attention',
        error_loading_orders: 'Error loading orders!',
        error_loading_details: 'Error loading order details!',
        error_changing_status: 'Error changing order status!',
        success_status_changed: 'Status changed successfully!',
        select_status_warning: 'Please, select a status.',

        // Customer review
        customer_review: 'Customer Review',
        rating: 'Rating',
        review_comment: 'Comment',
      },
      s3Analytics: {
        title: 'S3 Analytics',
        startDate: 'Start Date',
        endDate: 'End Date',
        pluginspaceId: 'Pluginspace ID',
        pluginspaceIdPlaceholder: 'Enter pluginspace ID',
        method: 'Method',
        methodPlaceholder: 'Enter method (GET, POST, etc.)',
        loadData: 'Load Data',
        generateAIAnalysis: 'Generate AI Analysis',
        chatWithAI: 'Chat with AI',
        showRanking: 'Show Ranking',
        analyzeWithAI: 'Analyze with AI',
        close: 'Close',
        totalRequests: 'Total Requests',
        totalCost: 'Total Cost',
        averageCostPerRequest: 'Average Cost per Request',
        consumptionByPluginspace: 'Consumption by Pluginspace',
        consumptionByMethod: 'Consumption by Method',
        consumptionByDate: 'Consumption by Date',
        costAnalysis: 'Cost Analysis',
        aiAnalysis: 'AI Analysis',
        chatMessage: 'Enter your question about the data...',
        speakAnalysis: 'Listen Analysis',
        filterData: 'Filter Data',
        noDataFound: 'No data found for the selected filters',
        errorLoadingData: 'Error loading data',
        errorGeneratingAnalysis: 'Error generating AI analysis',
        analysisGenerated: 'Analysis generated successfully!',
        dataLoaded: 'Data loaded successfully!',
        rankingData: 'Ranking Data',
        aiChatResponse: 'AI Response',
        s3Analytics: 'S3 Analytics',
        filters: 'Filters',
        totalConsumption: 'Total Consumption',
        totalRecords: 'Total Records',
        error: 'Error',
        fetchError: 'Error fetching S3 data',
        aiAnalysisError: 'Error generating AI analysis',
        aiChatError: 'Error chatting with AI',
        askQuestion: 'Enter your question about the data...',
        ask: 'Ask',
        cancel: 'Cancel',
        ok: 'OK',
        aiResponse: 'AI Response',
        aiAnalysisTitle: 'AI Analysis',
        account: 'Account',
        pluginspace: 'Store',
        uniquePluginspaces: 'Unique Stores',
        methodDistribution: 'Distribution by Method',
        timeAnalysis: 'Temporal Analysis',
        dataTable: 'Data Table',
        showingFirst10: 'Showing the first 10',
        of: 'of',
        records: 'records',
        consumption: 'Consumption',
        cost: 'Cost',
        date: 'Date',
        allMethods: 'All Methods',
        exportData: 'Export Data',
      },
      hospitality_store: {
        establishment: 'Establishment',
        select_establishment: 'Select...',
        link: 'Link',
        status: 'Status',
        payment_integrated: 'Integrated Payment',
        order: 'Order',
        store_image: 'Store Image',
        store_image_hint: 'Select an image representative of the store',
        description: 'Description',
        cnpj: 'CNPJ',
        code: 'Code',
        store_id_placeholder: 'Store ID',
        type: 'Type',
        store_type_placeholder: 'Establishment type',
        no_store_found: 'No establishment found.',
        edit_store: 'Edit Establishment',
        edit_store_subtitle: 'Edit the establishment data.',
      },
      stores_pages: {
        title: 'Establishments',
        subtitle: 'Here are the hotel establishments listed along with their respective actions.',
        create: 'Create Establishment',
        no_results: 'No establishment found.',
        table: {
          code: 'Code',
          image: 'Image',
          name: 'Store',
          cnpj: 'CNPJ',
          vinculation: 'Vinculation',
          vinculation_default: 'Default',
          vinculation_dynamic: 'Dynamic',
          type: 'Type',
          order: 'Order',
          status: 'Status',
          status_active: 'Active',
          status_inactive: 'Inactive',
          payment_integrated: 'Integrated Payment',
          actions: 'Actions',
        },
        actions: {
          edit: 'Edit Establishment',
          delete_confirm: 'Are you sure you want to delete?',
          delete: 'Delete Establishment',
        },
        delete_success: 'Establishment deleted successfully.',
        delete_error: 'Error deleting the establishment. Please try again.',
        success: 'Success!',
        error: 'Error!',
      },
      stores_pages_create: {
        title: 'Create Establishment',
        subtitle: 'Create a new establishment for the hotel.',
        form: {
          establishment: 'Establishment',
          select_placeholder: 'Select...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Status',
          status_options: {active: 'Active', inactive: 'Inactive'},
          payment_integrated: 'Integrated Payment',
          payment_options: {active: 'Active', inactive: 'Inactive'},
          order: 'Order',
          image_label: 'Establishment Image',
          image_smalltext: 'Select an image representative of the establishment',
          description: 'Description',
          info_title: 'Establishment Information',
          cnpj: 'CNPJ',
          code: 'Code',
          type: 'Type',
          vinculation_label: 'Vinculation Type',
          vinculation_options: {default: 'Default', dynamic: 'Dynamic'},
          empty_message: 'No establishment found.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'Store ID',
        },
        console_messages: {
          image_upload_error: 'Image upload error',
        },
        messages: {
          warning_title: 'Attention',
          select_store_warning: 'Please select a valid establishment before saving.',
          error_saving: 'An error occurred while saving the establishment. Please try again.',
          success_saved: 'Establishment saved successfully.',
        },
      },
      stores_pages_edit: {
        title: 'Edit Establishment',
        subtitle: 'Edit the establishment data.',
        form: {
          establishment: 'Establishment',
          select_placeholder: 'Select...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Status',
          status_options: {active: 'Active', inactive: 'Inactive'},
          payment_integrated: 'Integrated Payment',
          payment_options: {active: 'Active', inactive: 'Inactive'},
          order: 'Order',
          image_label: 'Establishment Image',
          image_smalltext: 'Select an image representative of the establishment',
          description: 'Description',
          info_title: 'Establishment Information',
          cnpj: 'CNPJ',
          code: 'Code',
          type: 'Type',
          vinculation_label: 'Vinculation Type',
          vinculation_options: {default: 'Default', dynamic: 'Dynamic'},
          empty_message: 'No establishment found.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'Store ID',
        },
        console_messages: {
          image_upload_error: 'Image upload error',
          image_remove_error: 'Error removing image on save',
        },
        messages: {
          success_updated: 'Establishment updated successfully.',
          error_updating: 'An error occurred while updating the establishment. Please try again.',
          payment_change_warning_title: 'Attention',
          payment_change_warning_text:
            'This change may change the value of reservations in progress at the time of check-out.',
          payment_confirm: 'Yes, continue',
          cancel: 'Cancel',
        },
      },
      hospitality_section: {
        index: {
          page_title: 'Publication Pages',
          page_subtitle:
            'Here are listed the content publication pages along with their respective actions.',
          add_button: 'Add Publication Page',
          filters: {
            sections: 'Publication Page',
          },
          table: {
            headers: {
              title: 'Title',
              order: 'Order',
              formTitle: 'Form Title',
              type: 'Type',
              actions: 'Actions',
            },
          },
          actions: {
            edit: 'Edit Publication Pages',
            delete: 'Delete Publication Pages',
          },
        },
        create: {
          page_title: 'Create Publication Pages',
          page_subtitle: 'Create a new content publication pages for the hotel.',
          add_button: 'Add Publication Pages',
          filters: {
            sections: 'Sections',
          },
        },
        edit: {
          page_title: 'Edit Publication Pages',
          page_subtitle: 'Edit the content publication pages data.',
        },
        // Dynamic translations for sections
        types: {
          category: 'Category',
          content: 'Content',
          simple: 'Simple',
          form: 'Form',
          page: 'Restaurant or Store',
        },
        status: {
          active: 'Active',
          inactive: 'Inactive',
        },
        actions: {
          create: 'Create',
          edit: 'Edit',
          delete: 'Delete',
          save: 'Save',
          cancel: 'Cancel',
          update: 'Update',
          remove_icon: 'Remove Icon',
          select_icon: 'Select Icon',
        },
        fields: {
          title: 'Button Title',
          type: 'Publication Pages Type',
          category: 'Category',
          order: 'Order',
          status: 'Status',
          icon: 'Icon',
          icon_selected: 'Icon Selected',
          icon_not_selected: 'No Icon Selected',
          icon_description: 'Select an icon from the list on the side for the section',
          icon_change_description:
            'Select a different icon from the list on the side or remove the current one',
        },
        placeholders: {
          title: 'Enter the button title',
          type: 'Select type',
          category: 'Select a category',
          order: '0',
          search_icon: 'Search icon...',
          all_categories: 'All categories',
        },
        warnings: {
          stores:
            'No store of type Dynamic was found.\nTo continue, go to Settings → Stores and Establishments and configure a store with type Dynamic.',
        },
        messages: {
          validation: {
            title_required: 'Title is required!',
            category_required: 'Select a category!',
            icon_required: 'Select an icon!',
          },
          success: {
            created: 'Publication Pages created successfully!',
            updated: 'Publication Pages updated successfully!',
            deleted: 'Publication Pages deleted successfully!',
          },
          error: {
            create: 'Error creating Publication Pages!',
            update: 'Error updating Publication Pages!',
            delete: 'Error deleting Publication Pages!',
            load: 'Error loading Publication Pages data!',
          },
          confirm: {
            delete_title: 'Are you sure?',
            delete_text: 'This action cannot be undone!',
            delete_confirm: 'Yes, delete!',
            delete_cancel: 'Cancel',
          },
          delete: {
            deleted_title: 'Publication Pages deleted',
            deleted_text: 'Deletion successful!',
            error_title: 'Error deleting Publication Pages!',
            error_text: 'An error occurred while deleting the Publication Pages. Please try again.',
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: 'Publication Categories',
          page_subtitle:
            'Here are listed the publication categories along with their respective actions.',
          add_button: 'Add Publication Category',
          filter_all: 'All',
          table: {
            headers: {
              title: 'Title',
              image: 'Image',
              summary: 'Summary',
              status: 'Status',
              classification: 'Classification',
              code: 'Code',
              actions: 'Actions',
            },
            actions: {
              edit: 'Edit Publication Category',
              delete: 'Delete Publication Category',
            },
          },
        },
        create: {
          page_title: 'Create Publication Category',
          page_subtitle: 'Create a new publication category for the hotel.',
          add_button: 'Add Publication Category',
          success: {
            created_title: 'Publication Category created',
            created_text: 'Registration completed successfully!',
          },
          error: {
            created_title: 'Error creating Publication Category!',
            created_text: 'An error occurred while creating the category. Please try again.',
          },
        },
        edit: {
          page_title: 'Edit Publication Category',
          page_subtitle: 'Edit the publication category data.',
          success: {
            created_title: 'Publication Category edited',
            created_text: 'Registration completed successfully!',
          },
          error: {
            created_title: 'Error editing Publication Category!',
            created_text: 'An error occurred while editing the category. Please try again.',
          },
        },
      },
      hospitality_post: {
        posts: 'Publications',
        index: {
          page_title: 'Publications',
          page_subtitle:
            'Here are listed the hotel publications along with their respective actions.',
          add_button: 'Add Publication',
          filter_all: 'All',
          filter: 'Categories',
          table: {
            headers: {
              title: 'Title',
              image: 'Image',
              summary: 'Summary',
              order: 'Order',
              status: 'Status',
              classification: 'Classification',
              actions: 'Actions',
            },
            actions: {
              edit: 'Edit Publication',
              delete: 'Delete Publication',
            },
          },
        },
        create: {
          page_title: 'Create Publication',
          page_subtitle: 'Create a new publication for the hotel.',
          success: {
            created_title: 'Publication created',
            created_text: 'Registration completed successfully!',
          },
          error: {
            created_title: 'Error creating Publication!',
            created_text: 'An error occurred while creating the publication. Please try again.',
          },
        },
        edit: {
          page_title: 'Edit Publication',
          page_subtitle: 'Edit the publication data.',
          success: {
            created_title: 'Publication edited',
            created_text: 'Registration completed successfully!',
          },
          error: {
            created_title: 'Error editing Publication!',
            created_text: 'An error occurred while editing the publication. Please try again.',
          },
        },
        form_validate: {
          title_required: 'Title is required!',
          summary_required: 'Summary is required!',
          classification_required: 'Classification is required!',
          content_required: 'Content is required!',
          fields_missing: 'Please check if you have filled in all fields!',
        },
      },
      hospitality_post_page: {
        types: {
          simple: 'Simple',
          section: 'Section',
          form: 'Form',
          category: 'Category',
        },
        index: {
          page_title: 'Publication Pages',
          page_subtitle:
            'Here are listed the content publication pages along with their respective actions.',
          add_button: 'Add Publication Page',
          edit_button: 'Edit Publication Page',
          delete_button: 'Delete Publication Page',
        },
        create: {
          page_title: 'Create Publication Page',
          page_subtitle: 'Create a new content publication page for the hotel.',
          form: {
            title: 'Publication Page Title',
            type: 'Publication Page Type',
            status: 'Status',
          },
          icon: {
            icon: 'SVG Icon',
            lib: 'SVG Icon Library',
            search: 'Search icon...',
            category: 'Icon Category',
            description: 'Select an icon from the list on the side for the publication page',
            selected: 'Selected Icon',
            no_selected: 'No Icon Selected',
            selected_description:
              'Select an icon from the list on the side for the publication page',
            no_selected_description:
              'No icon selected. Select an icon from the list on the side for the publication page',
            change_description:
              'Select a different icon from the list on the side or remove the current one',
          },
          success: {
            created_title: 'Publication Page created',
            created_text: 'Registration completed successfully!',
          },
          error: {
            created_title: 'Error creating Publication Page!',
            created_text: 'An error occurred while creating the page. Please try again.',
          },
        },
        edit: {
          page_title: 'Edit Publication Page',
          page_subtitle: 'Edit the content publication page data.',
          form: {
            title: 'Publication Page Title',
            type: 'Publication Page Type',
            status: 'Status',
          },
          icon: {
            icon: 'SVG Icon',
            lib: 'SVG Icon Library',
            search: 'Search icon...',
            category: 'Icon Category',
            description: 'Select an icon from the list on the side for the publication page',
            selected: 'Selected Icon',
            no_selected: 'No Icon Selected',
            selected_description:
              'Select an icon from the list on the side for the publication page',
            no_selected_description:
              'No icon selected. Select an icon from the list on the side for the publication page',
            change_description:
              'Select a different icon from the list on the side or remove the current one',
          },
          success: {
            created_title: 'Publication Page edited',
            created_text: 'Edit completed successfully!',
          },
          error: {
            created_title: 'Error editing Publication Page!',
            created_text: 'An error occurred while editing the page. Please try again.',
          },
        },
      },
      // Translations for Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: 'Service Reservations',
        page_subtitle: 'Manage service reservations',
        breadcrumb_services: 'Booking Services',
        breadcrumb_booking: 'Booking Services',
        create_button: 'Create Service Reservation',

        // Table headers
        table_image: 'Image',
        table_title: 'Title',
        table_order: 'Order',
        table_status: 'Status',
        table_actions: 'Actions',

        // Table actions
        action_edit: 'Edit',
        action_delete: 'Delete',

        // Status
        status_active: 'Active',
        status_inactive: 'Inactive',

        // Messages
        delete_success: 'Reservation deleted',
        delete_error: 'Failed to delete reservation',
        delete_confirm: 'Confirm deletion?',

        // Create page
        create_title: 'Create Service Reservation',
        create_subtitle: 'Fill in the information to create a new service reservation',

        // Edit page
        edit_title: 'Edit Hotel Reservation',
        edit_subtitle: 'Edit reservation information',

        // Form fields
        field_title_label: 'Title',
        field_title_placeholder: 'Ex.: Spa Reservation',
        field_status_label: 'Status',
        field_description_label: 'Description',
        field_image_label: 'Image',
        field_icon_label: 'Icon',

        // Icon picker
        icon_choose: 'Choose Icon',
        icon_choose_modal: 'Choose Icon',

        // Day configuration
        day_config_title: 'Day Configuration',
        day_config_info_line1:
          "If the day doesn't have defined time slots, this limit applies to the whole day.",
        day_config_info_line2:
          'If the day has time slots with intervals, this limit applies to each time slot/interval.',
        day_configure: 'Configure',
        day_periods_title: 'Time Periods',
        day_period_add: 'Add Period',
        day_period_max: 'Maximum 3 periods',
        day_period_none: 'No period configured. Add at least one period.',
        day_period_overlap: 'Time periods cannot overlap. Please adjust the configured periods.',
        day_period_label: 'Period',
        day_period_remove: 'Remove',
        day_interval_label: 'Interval (min)',
        day_start_time_label: 'Start Time',
        day_end_time_label: 'End Time',

        // Day names
        day_sunday: 'Sunday',
        day_monday: 'Monday',
        day_tuesday: 'Tuesday',
        day_wednesday: 'Wednesday',
        day_thursday: 'Thursday',
        day_friday: 'Friday',
        day_saturday: 'Saturday',

        // Grid selection
        grid_title: 'Linked Grids',
        grid_select: 'Select Grids',
        grid_selected: 'grid(s) selected',
        grid_capacity: 'Capacity',
        grid_multiple: 'Multiple',
        grid_multiple_yes: 'Yes',
        grid_multiple_no: 'No',
        grid_status_active: 'Active',
        grid_status_inactive: 'Inactive',

        // Action buttons
        button_back: 'Back',
        button_save: 'Save',
        button_update: 'Update',
        button_create: 'Create',
        button_cancel: 'Cancel',
        button_confirm: 'Confirm',

        // Validation messages
        validation_title_required: 'Required field',
        validation_title_text: 'Title is required.',
        validation_icon_required: 'Required field',
        validation_icon_text: 'Select an icon.',
        validation_day_required: 'Configuration required',
        validation_day_text: 'Configure at least one day of the week.',

        // Success messages
        success_created: 'Reservation created',
        success_created_text: 'The reservation was created successfully!',
        success_updated: 'Reservation updated',
        success_updated_text: 'The reservation was updated successfully!',

        // Error messages
        error_create: 'Error creating',
        error_create_text: 'An error occurred while creating the reservation.',
        error_update: 'Error updating',
        error_update_text: 'An error occurred while updating the reservation.',
        error_save: 'Error',
        error_save_text: 'An error occurred while saving the reservation.',
        error_load: 'Error',
        error_load_text: 'Error loading reservation data.',

        // Breadcrumbs
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hospitality: 'Hospitality',
        breadcrumb_hotel_reservations: 'Hotel Reservations',
        breadcrumb_create: 'Create',
        breadcrumb_edit: 'Edit',
      },
      users: {
        houserkeeping: 'House Keeping',
        maintenancetechnician: 'Maintenance Technician',
        receptionist: 'Receptionist',
        manager: 'Manager',
        administrator: 'Administrator',
        waiter: 'Waiter',
        kitchenchief: 'Kitchen Chief / Chef',
        warehouse: 'Warehouse Manager',
        concierge: 'Concierge',
        messenger: 'Messenger',
        receptionsupervisor: 'Reception Supervisor',
        telephonist: 'Telephonist',
        cook: 'Cook',
        barman: 'Barman / Bartender',
        roomserviceattendant: 'Room Service Attendant',
        steward: 'Steward (Kitchen Cleaning)',
        sommelier: 'Sommelier',
        plumber: 'Plumber',
        airconditiontechnician: 'Air Conditioning Technician',
        maintenancesupervisor: 'Maintenance Supervisor',
        reservationagent: 'Reservation Agent',
        reservationcoordinator: 'Reservation Coordinator',
        salesexecutive: 'Sales Executive',
        revenuemanager: 'Revenue Manager',
        commercialmanager: 'Commercial Manager',
        administrativeassistant: 'Administrative Assistant',
        financeaccountspayable: 'Finance / Accounts Payable',
        accountant: 'Accountant',
        humanresources: 'Human Resources',
        purchasingwarehouse: 'Purchasing / Warehouse',
        recreator: 'Recreator',
        activityinstructor: 'Activity Instructor',
        experiencecoordinator: 'Experience Coordinator',
        tourguide: 'Tour Guide',
        childmonitor: 'Child Monitor',
        securityguard: 'Security Guard',
        doorman: 'Doorman',
        accesscontroller: 'Access Controller',
        securitysupervisor: 'Security Supervisor',
        generalmanager: 'General Manager',
        assistantmanager: 'Assistant Manager',
        operationalmanager: 'Operational Manager',
        departmentsupervisorscoordinators: 'Department Supervisors and Coordinators',
        floormanager: 'Floor Manager',
        governancesupervisor: 'Housekeeping Supervisor',
        generalservicesassistant: 'General Services Assistant',
        laundryattendant: 'Laundry Attendant',
        laundrymanager: 'Linen Manager',
        machinist: 'Machine Operator',
        ironer: 'Ironer',
        electrician: 'Electrician',
        carpenter: 'Carpenter',
      },
    },
  },
}

export {messages}
// hospitality_experiences block moved inside translations below
